import {
    IIndicatorInstances,
    IIndicatorInstance,
    getInputLabelText,
    DeepCopyIndicators,
    IIndicator
} from "./indicators";
import {
    Component,
    OnInit,
    ViewChild,
    Input,
    ElementRef,
    NgZone,
    ChangeDetectionStrategy,
    Injector,
    OnDestroy
} from "@angular/core";

import "anychart";
//import "anychart/themes/dark_earth.js";
import { anychartDark, darkTheme } from "./anychart.dakrk.theme";
import {
    HistoryItemPeriod,
    historyPeriods,
    PERIOD_TIMESTAMP_MULTIPLIER,
    IPeriodsUpdate
} from "../../interfaces/historyItem";
import { dragAndDropSymbol } from "../../services/dragAndDropSymbol/dragAndDropSymbol.service";
import { Subscription, Subject } from "rxjs";

import * as $ from "jquery";

import "bootstrap";
import { ChartColorTable } from "./achart.colors";
import { StockSeriesType, EventType, LegendItemIconType, ChartMarkerType } from "./achart.annotation.tools";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { spaceAfterDataService } from "../../services/spaceAfterDataService/spaceAfterData.service";
import { getHistoryItemPeriodValue, IHistoryItem } from "../../interfaces/historyItem";

import * as moment from "moment";

import { ShowIndicatorModal } from "../modals/IndicatorModal/ShowIndicatorModal";
import { ShowChartOptionsModal } from "../modals/ChartOptionsModal/ChartOptionsModal.component";
import { MenuItem } from "../wolfie-context-menu/menu-item";
import { Button } from "../wolfie-context-menu/button";
import { IChartConfig } from "../../interfaces/IChartConfig";
import { ChartButtonsVisibleService } from "../../services/ChartButtonsVisible.service";
import { ShowChartTooltipService } from "../../services/ShoChartTooltip.service";
import { computeValueES, emaBlackPeriod, emaWhitePeriod, IEmaResult } from "../../model/monitor.selected.symbol";
import { AppComponentBase } from "../../services/AppComponentBase";
import { BoxQuotaData } from "../../model/box.quote.data";
import { tradingLines } from "../../model/tradingLines";

import { ShowSavedStrategiesModal } from "../modals/SavedStrategiesModal/show-saved-strategies-modal";
import { ShowTemplatesModal } from "../modals/templates-modal/show-templates-modal";
import { ITemplate } from "../template-preview/template-preview.component";

import * as ColorFn from "color";
import { ColorEvent } from "ngx-color";
import { callNextAsync } from "../../services/BaseService";
import { Utils, Position2D } from "../../utils";
import { ScannerChartingStudy } from "../scanner/interfaces/scanner.enums";
import { Providers } from "../../enums/providers";
import { chartLinesService } from '../../services/chartLinesService';
import { Ticket } from '../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { Annotation } from '../../model/annotation';
import { forEach } from '@angular/router/src/utils/collection';
import {IOrdersData} from "../../interfaces/service.response";
//import { TradeLine } from '../../services/GAIN/models';

@Component({
    selector: "achart",
    template: require('./achart.component.html'),
    styles: [require('./achart.component.css')]
})
export class AChartComponent extends AppComponentBase implements OnInit, OnDestroy {
    @Input()
    name: string = "";

    @Input()
    itemID: string = "";
    @Input()
    layoutID: string = "";
    @Input()
    entrySignalCaption: string = "";

    @ViewChild("chartContainer")
    container?: ElementRef;

    public seriesTypes: { id: string; label: string; image?: string }[] = [];

    public _currentRequestId: string = "";
    private _requestIdHistory: string[] = [];

    public _loadedDataMax: number = new Date(1970, 1, 1).getTime();
    public _loadedDataMin: number = new Date(2200, 1, 1).getTime();

    private _currentDraggedSymbol: string = "";
    private _preloader!: anychart.ui.Preloader;

    private _periodsMaxTime = Number.MAX_VALUE;

    private _newTextMarkerIndex = 0;

    public get newTextMarkerIndex() {
        return this._newTextMarkerIndex++;
    }

    Instance: AChartComponent;
    InstanceId: number = Date.now() + Math.random();

    private isSelectedAnyChart: boolean = false;

    loadDataAfterRangeChanged: boolean = true;

    public get Config(): IChartConfig {
        return this.workspace.charts[this.itemID];
    }

    private _chartObj: any;
    set chart(v: anychart.charts.Stock) {
        this._chartObj = v;
    }

    get chart(): anychart.charts.Stock {
        return <anychart.charts.Stock>this._chartObj;
    }
    private _initialized: boolean = false;
    @Input()
    public get symbol() {
        return this.Config.Symbol;
    }

    private AskSubjectSubscriber: any;
    public set symbol(v: string) {
        if (this._initialized == true) {
            let currentSymbol = this.symbol;

            this.workspace.boxes.filter(s => {
                if (s.Symbol === currentSymbol) {
                    this.AskSubjectSubscriber = s.askSubject;
                    this.AskSubjectSubscriber.subscribe((l: any) => {
                        if (!this.workspace.appSettings.PriceIndicatorFromPeriod) {
                            if (s.Symbol == this.symbol) {
                                this.updateAskIndicator(s.Ask, s.askUp);
                            }
                        }
                    });
                }
            });

            if (this.Config.Symbol != v) {
                this.Config.Symbol = v;
                this.onSelectNewSymbol(v);
            }
        }
    }

    public get item(): BoxQuotaData | null {
        let res = this.workspace.boxes.filter(x => x.Symbol == this.symbol);
        return res.length > 0 ? res[0] : null;
    }

    public get Decimal(): number {
        if (this.item) {
            return this.item.Decimal;
        } else {
            return 5;
        }
    }

    public get period(): HistoryItemPeriod {
        return this.Config.Period[this.Config.DisplayMode];
    }

    public set period(v: HistoryItemPeriod) {
        var canRefresh = v != this.period || this.hardRefresh;

        let next = this.workspace.getCorrectPeriod(v);

        if (this.Config.setPeriod) this.Config.setPeriod(this.Config.DisplayMode, next);

        if (next != HistoryItemPeriod.Unknown && this.workspace.IsLoged() && canRefresh) {
            //  this.hardRefreshPeriod();
            this.refreshPeriod(next);
            this.hardRefresh = false;
        }
        this.canShowTrades = false;
        this.tradeLinesVisibilityService.drawActiveState();
    }

    public hardRefresh: boolean = false;
    public hardRefreshPeriod() {
        // for (let l = 0; l < this.tradingLines.length; l++) {
        //     this.tradingLines[l].tempTradeData = null;
        //     this.tradingLines[l].removeTradeLines();
        // }

        let tempPeriods = historyPeriods().filter(l => {
            return l.id == this.period;
        });

        let temp = this.workspace.periodsList.filter(v => {
            return v.id == this.period || (v.id != this.period && v.Order >= tempPeriods[0].Order);
        });

        this.hardRefresh = true;
        this.period = this.workspace.getCorrectPeriod(this.period);
        this.globaGridMode.refreshProviderSignal.next(this.itemID);
    }

    public refreshPeriosCalled: boolean = false;

    public refreshPeriod(v?: HistoryItemPeriod, mark?: boolean) {
        this.refreshPeriosCalled = true;
        if (v == undefined) {
            v = this.workspace.getCorrectPeriod(this.period);
        }

        this.showPreloader();

        this.periodValue = getHistoryItemPeriodValue(v);

        this._requestIdHistory = [];
        // for skip redundand data requests
        this._loadedDataMax = new Date(1970, 1, 1).getTime();
        this._loadedDataMin = new Date(2200, 1, 1).getTime();

        if (v != undefined) this.loadChartData(v, 2000, true);
    }

    public get DefaultSupportLinesColor() {
        return this.Config.DisplayMode == ChartDisplayMode.WIZARD ? "black" : "white";
    }

    public get SupportLinesColor() {
        return this.Config.SupportLinesColor || this.DefaultSupportLinesColor;
    }

    public set SupportLinesColor(v) {
        this.Config.SupportLinesColor = v;
        this.applySupportLinesColor();
    }

    applySupportLinesColor() {
        this.getSupportLines().forEach((sl: any) => sl.stroke(this.SupportLinesColor));
    }

    private _BackgroundColor: string = "";
    public get BackgroundColor(): string {
        if (this.chart && this._BackgroundColor == "") {
            return this.Config.BackgroundColor;
            //<string>this.chart.background().fill();
        }
        return this._BackgroundColor;
    }
    public set BackgroundColor(v: string) {
        this._BackgroundColor = v;
        this.Config.BackgroundColor = v;
        //this.workspace.save();

        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.setBackgroundColor(v);
        }
    }

    public set CrosshairColor(v: string) {
        this.Config.CrosshairColor = v;
        const crosshair = this.chart.crosshair();
        crosshair.xStroke(v);
        crosshair.yStroke(v);
    }

    private setBackgroundColor(v: string) {
        this.chart.background(v);
        this.xGrid().palette([v]);
        this.plot()
            .xGrid()
            .palette([v]);
        this.plot().background(v);

        this.xGrid().fill(v);
        this.plot()
            .xMinorGrid()
            .fill(v);

        Object.keys(this.indicatorInstances).forEach(key => {
            this.indicatorInstances[key].forEach(ind => {
                if (ind && ind.indicator && ind.indicator.defaults && ind.indicator.defaults.item) {
                    ind.indicator.defaults.item
                        .filter(item => item.name == "plotIndex")
                        .forEach(item => {
                            let plotIndex = Number(item.value);
                            // all indicators on one plot 0- chart 1-tabs 2-indicators
                            plotIndex = plotIndex > 0 ? 2 : 0;
                            this.xGrid(plotIndex).palette([v]);

                            this.chart.plot(plotIndex).background(v);
                            this.chart
                                .plot(plotIndex)
                                .xGrid()
                                .palette([v]);
                            this.chart
                                .plot(plotIndex)
                                .xGrid(plotIndex)
                                .palette([v]);
                        });
                }
            });
        });
    }

    private _FontColor: string = "";
    public get FontColor(): string {
        if (this.chart && this._FontColor == "") {
            return this.Config.FontColor;
        }
        return this._FontColor;
    }

    public set FontColor(v: string) {
        this._FontColor = v;
        this.Config.FontColor = v;
        this.workspace.save();
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.setChartFontColor(v);
        }
    }

    public setChartFontColor(v: string) {
        this.getPlots().forEach((plot, index) => {
            if (index == 0 || index == 2) {
                plot.xAxis()
                    .labels()
                    .fontColor(v);
                plot.xAxis()
                    .minorLabels()
                    .fontColor(v);
                plot.yAxis()
                    .labels()
                    .fontColor(v);
                plot.yAxis()
                    .minorLabels()
                    .fontColor(v);

                if (index == 2) {
                    plot.yAxis(1)
                        .labels()
                        .fontColor(v);
                    plot.yAxis(1)
                        .minorLabels()
                        .fontColor(v);
                }
            }

            plot.legend().fontColor(v);
            plot.legend()
                .title()
                .fontColor(v);
        });
        this.chart
            .scroller()
            .xAxis()
            .minorLabels()
            .fontColor(v);
        this.chart
            .scroller()
            .xAxis()
            .labels()
            .fontColor(v);
    }
    private _GridColor: string = "";
    public get GridColor(): string {
        if (this.chart && this._GridColor == "") {
            return this.Config.GridColor;
        }
        return this._GridColor;
    }

    public set GridColor(v: string) {
        this._GridColor = v;
        this.Config.GridColor = v;
        this.workspace.save();
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            //   this.xGrid().stroke(v);
            // this.plot().yGrid().stroke(v);
            Object.keys(this.indicatorInstances).forEach(key => {
                this.indicatorInstances[key].forEach(ind => {
                    ind.indicator.defaults.item
                        .filter(item => item.name == "plotIndex")
                        .forEach(item => {
                            let plotIndex = Number(item.value);
                            // all indicators on one plot 0- chart 1-tabs 2-indicators
                            plotIndex = plotIndex > 0 ? 2 : 0;
                            // this.plot(plotIndex)
                            //     .xGrid()
                            //     .stroke(v);
                            // this.plot(plotIndex)
                            //     .yGrid()
                            //     .stroke(v);
                        });
                });
            });
        }
    }

    private _MinorGridColor: string = "";
    public get MinorGridColor(): string {
        if (this.chart && this._MinorGridColor == "") {
            return this.Config.MinorGridColor;
        }
        return this._MinorGridColor;
    }

    public set MinorGridColor(v: string) {
        this._MinorGridColor = v;
        this.Config.MinorGridColor = v;
        this.workspace.save();
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.plot()
                .xMinorGrid()
                .stroke(v);

            Object.keys(this.indicatorInstances).forEach(key => {
                this.indicatorInstances[key].forEach(ind => {
                    ind.indicator.defaults.item
                        .filter(item => item.name == "plotIndex")
                        .forEach(item => {
                            let plotIndex = Number(item.value);
                            // all indicators on one plot 0- chart 1-tabs 2-indicators
                            plotIndex = plotIndex > 0 ? 2 : 0;
                            this.plot(plotIndex)
                                .xMinorGrid()
                                .stroke(v);
                            // this.plot(plotIndex)
                            //     .yMinorGrid()
                            //     .stroke(v);
                        });
                });
            });
        }
    }

    private _AxisColor: string = "";
    public get AxisColor(): string {
        if (this.chart && this._AxisColor == "") {
            return this.Config.AxisColor;
        }
        return this._AxisColor;
    }

    public set AxisColor(v: string) {
        this._AxisColor = v;
        this.Config.AxisColor = v;
        this.workspace.save();
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.setChartAxisColor(v);
        }
    }

    public setChartAxisColor(v: string) {
        this.plot()
            .xAxis()
            .ticks()
            .stroke(v);
        this.plot()
            .xAxis()
            .minorTicks()
            .stroke(v);
        this.plot()
            .yAxis()
            .stroke(v);

        this.plot()
            .yAxis()
            .ticks()
            .stroke(v);

        Object.keys(this.indicatorInstances).forEach(key => {
            this.indicatorInstances[key].forEach(ind => {
                if (ind && ind.indicator && ind.indicator.defaults && ind.indicator.defaults.item) {
                    ind.indicator.defaults.item
                        .filter(item => item.name == "plotIndex")
                        .forEach(item => {
                            let plotIndex = Number(item.value);
                            // all indicators on one plot 0- chart 1-tabs 2-indicators
                            plotIndex = plotIndex > 0 ? 2 : 0;
                            this.plot(plotIndex)
                                .xAxis()
                                .ticks()
                                .stroke(v);
                            this.plot(plotIndex)
                                .xAxis()
                                .minorTicks()
                                .stroke(v);
                            this.plot(plotIndex)
                                .yAxis()
                                .stroke(v);
                            this.plot(plotIndex)
                                .yAxis()
                                .ticks()
                                .stroke(v);
                        });
                }
            });
        });
    }

    private _CandleStickSerieBorderColor: string = "";
    public get CandleStickSerieBorderColor(): string {
        if (this.chart && this._CandleStickSerieBorderColor == "") {
            return this.Config.CandleStickSerieBorderColor;
        }
        return this._CandleStickSerieBorderColor;
    }

    public set CandleStickSerieBorderColor(v: string) {
        this._CandleStickSerieBorderColor = v;
        this.Config.CandleStickSerieBorderColor = v;
        this.workspace.save();
        if (this.candleStickSerie) {
            this.candleStickSerie.risingStroke(v);
            this.candleStickSerie.fallingStroke(v);
        }
    }

    private _CandleStickSerieRisingColor: string = "";
    public get CandleStickSerieRisingColor(): string {
        if (this.chart && this._CandleStickSerieRisingColor == "") {
            return this.Config.CandleStickSerieRisingColor;
            //ChartColorTable.RaisingColor
        }
        return this._CandleStickSerieRisingColor;
    }

    public set CandleStickSerieRisingColor(v: string) {
        this._CandleStickSerieRisingColor = v;
        this.Config.CandleStickSerieRisingColor = v;
        this.workspace.save();
        if (this.candleStickSerie) {
            this.candleStickSerie.risingFill(v);
        }
    }

    private _CandleStickSerieFallingColor: string = "";
    public get CandleStickSerieFallingColor(): string {
        if (this.chart && this._CandleStickSerieFallingColor == "") {
            return this.Config.CandleStickSerieFallingColor;
        }
        return this._CandleStickSerieFallingColor;
    }

    public set CandleStickSerieFallingColor(v: string) {
        this._CandleStickSerieFallingColor = v;
        this.Config.CandleStickSerieFallingColor = v;
        this.workspace.save();
        if (this.candleStickSerie) {
            this.candleStickSerie.fallingFill(v);
        }
    }

    private _LineSeriesColor: string = "";
    public get LineSeriesColor(): string {
        if (this.chart && this._LineSeriesColor == "") {
            return this.Config.LineSeriesColor;
        }
        return this._LineSeriesColor;
    }

    public set LineSeriesColor(v: string) {
        this._LineSeriesColor = v;
        this.Config.LineSeriesColor = v;
        this.workspace.save();
        if (this.lineSerie && this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.lineSerie.stroke(v);
            this.lineSerie
                .markers()
                .stroke(v)
                .fill(v);
        }
    }

    private _WizardLineSeriesWidth: string = "";
    public get WizardLineSeriesWidth(): string {
        if (this.chart && this._WizardLineSeriesWidth == "") {
            this._WizardLineSeriesWidth = this.Config.WizardLineSeriesWidth;
        }
        return this._WizardLineSeriesWidth;
    }

    public set WizardLineSeriesWidth(value: string) {
        this._WizardLineSeriesWidth = value;
    }

    private _WizardLineSeriesColor: string = "";
    public get WizardLineSeriesColor(): string {
        if (this.chart && this._WizardLineSeriesColor == "") {
            this._WizardLineSeriesColor = this.Config.WizardLineSeriesColor;
        }
        return this._WizardLineSeriesColor;
    }

    public set WizardLineSeriesColor(v: string) {
        this._WizardLineSeriesColor = v;
        this.Config.WizardLineSeriesColor = v;
        this.workspace.save();
        if (this.lineSerie && this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
            this.lineSerie.stroke(v);
            this.lineSerie
                .markers()
                .stroke(v)
                .fill(v);
        }
    }

    private _chartSerieType: StockSeriesType = StockSeriesType.LINE;
    public get chartSerieType(): StockSeriesType {
        return this._chartSerieType;
    }

    get SignalCaption() {
        return this.entrySignalCaption;
    }

    public wizard: any = null;
    private _currentMaxHigh: number = -1;
    private _currentMinLow: number = -1;
    private _dataLength: number = -1;

    public mapIndexToTime: { [key: string]: number } = {};
    public mapTime: { [key: string]: number } = {};
    public mapMatcher: number[] = [];

    public Trimmed: number[] = [];
    public pipValue: number = 0;
    public _timeRange: number = 0;

    public addSpaceVerifier = 19;
    public get minRangeValue(): number {
        return this._loadedDataMin - this.numOfPoints * this.periodValue;
    }

    public get maxRangeValue(): number {
        return this.showSpaceAfterData == true
            ? this._loadedDataMax + 16 * this.periodValue
            : this._loadedDataMax + 4 * this.periodValue;
    }

    public numOfPoints: number = 200;
    private _lastZ: number = -1;

    public set chartSerieType(v: StockSeriesType) {
        this._chartSerieType = v;
        if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
            this.Config.WizardSerie = v;
        } else if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.Config.ChartingSerie = v;
        }
        this.candleStickSerieEnabled = v === StockSeriesType.CANDLESTICK;
        this.ohclSerieEnabled = v === StockSeriesType.OHLC;
        this.lineSerieEnabled = v === StockSeriesType.LINE || v === StockSeriesType.PRICEPOINTLINE;
        this.lineSerie.markers(v === StockSeriesType.PRICEPOINTLINE);
    }

    public candleStickSerie!: anychart.core.stock.series.Candlestick;
    public get candleStickSerieEnabled(): boolean {
        if (this.candleStickSerie) {
            return this.candleStickSerie.enabled();
        } else {
            return false;
        }
    }
    public set candleStickSerieEnabled(v: boolean) {
        if (this.candleStickSerie) {
            this.candleStickSerie.name(this.symbol);
            this.candleStickSerie.enabled(v);

            if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
                if (this.TooltipSerie) {
                    this.TooltipSerie.tooltip(false);
                }

                this.candleStickSerie.tooltip(true);
                this.ohclSerie.tooltip(false);
            }

            if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
                this.candleStickSerie.tooltip(false);
                if (this.TooltipSerie) {
                    this.TooltipSerie.tooltip(true);
                }
            }

            if (this.Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                this.candleStickSerie.tooltip(false);
            }
        }
    }

    public lineSerie!: anychart.core.stock.series.Line;

    public get lineSerieEnabled(): boolean {
        if (this.lineSerie) {
            return this.lineSerie.enabled();
        } else {
            return false;
        }
    }
    public set lineSerieEnabled(v: boolean) {
        if (this.lineSerie) {
            if (this.TooltipSerie) {
                this.TooltipSerie.tooltip(true);
            }

            this.lineSerie.enabled(v);
        }
    }

    public ohclSerie!: anychart.core.stock.series.OHLC;

    public get ohclSerieEnabled(): boolean {
        if (this.ohclSerie) {
            return this.ohclSerie.enabled();
        } else {
            return false;
        }
    }
    public set ohclSerieEnabled(v: boolean) {
        if (this.ohclSerie) {
            if (this.TooltipSerie) this.TooltipSerie.tooltip(false);
            this.ohclSerie.enabled(v);

            if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
                //  this.candleStickSerie.tooltip(true);
                this.ohclSerie.tooltip(true);
            }

            if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
                //  this.candleStickSerie.tooltip(true);
                if (this.TooltipSerie) {
                    this.TooltipSerie.tooltip(true);
                }

                this.ohclSerie.tooltip(false);
            }

            if (this.Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                this.ohclSerie.tooltip(false);
            }
        }
    }

    private _dataTable: anychart.data.Table = anychart.data.table();
    public get dataTable(): anychart.data.Table {
        return this._dataTable;
    }
    public set dataTable(value: anychart.data.Table) {
        this._dataTable = value;
    }

    private _dataEntry: anychart.data.Table = anychart.data.table();
    public get dataEntry(): anychart.data.Table {
        return this._dataEntry;
    }
    public set dataEntry(value: anychart.data.Table) {
        this._dataEntry = value;
    }

    private dataTableWiz: anychart.data.Table = anychart.data.table();
    private dataTableEntry: anychart.data.Table = anychart.data.table();
    private dataTableHidden: anychart.data.Table = anychart.data.table();
    private dataTableResistance: anychart.data.Table = anychart.data.table();

    private _ohlcResistanceMapping!: anychart.data.TableMapping;
    private get ohlcResistanceMapping(): anychart.data.TableMapping {
        if (this._ohlcResistanceMapping == undefined) {
            this._ohlcResistanceMapping = this.dataTableResistance.mapAs();
            this._ohlcResistanceMapping.addField("open", 1, "first");
            this._ohlcResistanceMapping.addField("high", 2, "max");
            this._ohlcResistanceMapping.addField("low", 3, "min");
            this._ohlcResistanceMapping.addField("close", 4, "last");
            this._ohlcResistanceMapping.addField("volume", 5);
            this._ohlcResistanceMapping.addField("spot", 6);
        }
        return this._ohlcResistanceMapping;
    }

    private _ohlcMapping!: anychart.data.TableMapping;
    private get ohlcMapping(): anychart.data.TableMapping {
        if (this._ohlcMapping == undefined) {
            this._ohlcMapping = this.dataTable.mapAs();
            this._ohlcMapping.addField("open", 1, "first");
            this._ohlcMapping.addField("high", 2, "max");
            this._ohlcMapping.addField("low", 3, "min");
            this._ohlcMapping.addField("close", 4, "last");
            this._ohlcMapping.addField("volume", 5);
            this._ohlcMapping.addField("value", 4);
            this._ohlcMapping.addField("spot", 6);
        }
        return this._ohlcMapping;
    }

    private _lineMapping!: anychart.data.TableMapping;
    private get lineMapping(): anychart.data.TableMapping {
        if (this._lineMapping == undefined) {
            this._lineMapping = this.dataTable.mapAs();
            this._lineMapping.addField("value", 4); // Close
        }
        return this._lineMapping;
    }

    private _lineMappingFirst!: anychart.data.TableMapping;
    private get lineMappingFirst(): anychart.data.TableMapping {
        if (this._lineMappingFirst == undefined) {
            this._lineMappingFirst = this.dataTableWiz.mapAs();
            this._lineMappingFirst.addField("value", 3);
        }
        return this._lineMappingFirst;
    }

    private _lineMappingSecond!: anychart.data.TableMapping;
    private get lineMappingSecond(): anychart.data.TableMapping {
        if (this._lineMappingSecond == undefined) {
            this._lineMappingSecond = this.dataTableWiz.mapAs();
            this._lineMappingSecond.addField("value", 2);
        }
        return this._lineMappingSecond;
    }

    private _lineMappingEma2!: anychart.data.TableMapping;
    private get lineMappingEma2(): anychart.data.TableMapping {
        if (this._lineMappingEma2 == undefined) {
            this._lineMappingEma2 = this.dataTableWiz.mapAs({ value: 4, test: 0 });
        }
        return this._lineMappingEma2;
    }
    private _lineMappingEma!: anychart.data.TableMapping;
    private get lineMappingEma(): anychart.data.TableMapping {
        if (this._lineMappingEma == undefined) {
            this._lineMappingEma = this.dataEntry.mapAs({ value: 4, test: 0 });
        }
        return this._lineMappingEma;
    }
    /**BID ASK SPOT */
    private _ohlcBidAskSpotSerie!: anychart.core.stock.series.OHLC;
    private get ohlcBidAskSpotSerie(): anychart.core.stock.series.OHLC {
        return this._ohlcBidAskSpotSerie;
    }
    private set ohlcBidAskSpotSerie(v: anychart.core.stock.series.OHLC) {
        this._ohlcBidAskSpotSerie = v;
    }

    private _priceIndicator!: anychart.core.axisMarkers.CurrentPriceIndicator;
    private get priceIndicator(): anychart.core.axisMarkers.CurrentPriceIndicator {
        return this._priceIndicator;
    }
    public set showPriceIndicators(v: boolean) {
        if (this.priceIndicator) {
            this.priceIndicator.enabled(v);
        }
    }
    public get showPriceIndicators(): boolean {
        return this.priceIndicator ? this.priceIndicator.enabled() : false;
    }

    private _priceIndicatorColorUp: string = ChartColorTable.RaisingColor;
    public get priceIndicatorColorUp(): string {
        return this._priceIndicatorColorUp;
    }
    public set priceIndicatorColorUp(v: string) {
        this._priceIndicatorColorUp = v;
        this.priceIndicator.stroke(v, 1);
        this.priceIndicator
            .label()
            .background()
            .fill(v);
        this.priceIndicator.label().fontColor(ChartColorTable.White);
    }

    private _priceIndicatorColorDown: string = ChartColorTable.FaillingColor;
    public get priceIndicatorColorDown(): string {
        return this._priceIndicatorColorDown;
    }
    public set priceIndicatorColorDown(v: string) {
        this._priceIndicatorColorDown = v;
        this.priceIndicator.stroke(v, 1);
        this.priceIndicator
            .label()
            .background()
            .fill(v);
        this.priceIndicator.label().fontColor(ChartColorTable.White);
    }

    private _priceIndicatorUp: boolean = true;
    public get priceIndicatorUp(): boolean {
        return this._priceIndicatorUp;
    }
    public set priceIndicatorUp(v: boolean) {
        this._priceIndicatorUp = v;
        if (this.priceIndicator) {
            try {
                this.priceIndicator.stroke(v ? this.priceIndicatorColorUp : this.priceIndicatorColorDown, 1);

                if (this.priceIndicator.label() != null) {
                    this.priceIndicator
                        .label()
                        .background()
                        .fill(v ? this.priceIndicatorColorUp : this.priceIndicatorColorDown);
                    this.priceIndicator.label().fontColor(ChartColorTable.White);
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    private _selectionRange: number = 100; // last 200 data points
    public get selectionRange(): number {
        return this.period == HistoryItemPeriod.Mth1 ||
            this.period == HistoryItemPeriod.Week1 ||
            this.period == HistoryItemPeriod.Hr24
            ? this._selectionRange / 2
            : this._selectionRange;
    }

    public set selectionRange(v: number) {
        this._selectionRange = v;
    }

    private _isSelected: boolean = false;
    public get isSelected(): boolean {
        return this._isSelected;
    }
    public set isSelected(v: boolean) {
        this.zone.run(() => {
            this._isSelected = v;
            if (v) {
                this.chartInstanceService.select.next(this);
            } else {
                this.chartInstanceService.unselect.next(this);
            }
        });

        if (v == true) {
            this.globaGridMode.isSelectedChart.next(true);
        }
    }

    _lastQuoteData: number[] = [];
    _canUpdateDataTable: boolean = false;

    private _lastChangedSymbol: string = "";
    private _lockAllCharts: boolean = true;

    public _periodValue: number = getHistoryItemPeriodValue(HistoryItemPeriod.Min1);
    public get periodValue(): number {
        let v = getHistoryItemPeriodValue(this.period);
        return v; //this.periodValue;
    }
    public set periodValue(value: number) {
        this._periodValue = value;
    }

    private chartDragging: boolean = false;
    private _indicatorLoaded: boolean = false;

    private subscribtions: Subscription[] = [];
    private lastPriceIndicatorUp: boolean = false;
public counter:number = 0;
    constructor(
        injector: Injector,
        private dragAndDropSymbol: dragAndDropSymbol,
        private _showSpaceAfterDataService: spaceAfterDataService,
        private chartButtonsVisibleService: ChartButtonsVisibleService,
        private showChartTooltipService: ShowChartTooltipService,
        private tradeLinesVisibilityService:chartLinesService
    ) {
        super(injector);
        this.chartInstanceService.registerChart(this);
        this.subscribtions.push(
            this.activeLayoutChartService.subscriber.subscribe(l => {
                this.drawTitle();
            })
        );
        this.subscribtions.push(
            this.chartButtonsVisibleService.subscriber.subscribe(v => {
                this.drawTitle();
            })
        );
        this.subscribtions.push(
            this.showChartTooltipService.subscriber.subscribe(v => {
                this.chart.tooltip(this.Config.ShowTooltip);
            })
        );
        this.subscribtions.push(
            this.dataService.dataSubscriber.subscribe(response => {
                if (response.ReqID === this._currentRequestId) {
                    var Periods: IHistoryItem[] = [];
                    Periods = Periods.concat(response.Periods || []);
                    this.counter = Periods.length;
                    this.ChartAutoRedrawAfterAction(() => {
                        this.debug("CHART_1");
                        this.setChartData(Periods); //TODO: get max time

                        this._canUpdateDataTable = true;
                        if (this.Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                            this.updateSignals(this.dataEntry, this._periodsMaxTime);
                        } else {
                            this.precomputeEma(this.dataEntry, this._periodsMaxTime);
                        }
                    });
                }

                var P = (response.P || []).filter(pu => pu.PeriodType == this.period && pu.Symbol == this.symbol);

                if (P.length > 0 && this._canUpdateDataTable) {
                    if (this.dataTable) {
                        var periodFromServer = P[P.length - 1];
                        let time = periodFromServer.Period.t * PERIOD_TIMESTAMP_MULTIPLIER; //TODO: update max time
                        this._periodsMaxTime = time;
                        this.lastPriceIndicatorUp = this._lastQuoteData[4] < periodFromServer.Period.c;
                        this._lastQuoteData = [
                            time,
                            periodFromServer.Period.o,
                            periodFromServer.Period.h,
                            periodFromServer.Period.l,
                            periodFromServer.Period.c,
                            periodFromServer.Period.v,
                            0
                        ];
                        this.updateLastPeriod(P);
                    }
                }
                if (!this.workspace.appSettings.PriceIndicatorFromPeriod) {
                    this.workspace.boxes.filter(v => {
                        if (v.Symbol == this.symbol) {
                            this.updateAskIndicator(v.Ask, v.askUp);
                        }
                    });
                }
            })
        );
        this.subscribtions.push(
            this.chartDisplayModeService.subscriber.subscribe(currentDisplay => {
                this.canShowTrades = false;
                this.tradeLinesVisibilityService.drawActiveState();
                this.workspace._inTick++;
                this.showPreloader();

                this.hardRefresh = true;

                this.period = this.Config.Period[currentDisplay]; // this.workspace.getCorrectPeriod(this.Config.Period[currentDisplay]);
                console.log(`${this.itemID} this.updateChartDisplay`);
                this.updateChartDisplay(currentDisplay)
                    .then(r => {
                        this.workspace._inTick--;
                        this.workspace
                            .AppTick()
                            .then(() => {
                                this.hidePreloader();
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    })
                    .catch(e => {
                        console.error(e);
                    });
            })
        );
        this.subscribtions.push(
            this.dragAndDropSymbol.subscriber.subscribe(lastDraggedSymbol => {
                this._currentDraggedSymbol = lastDraggedSymbol;
            })
        );

        this.Instance = this;
        this.subscribtions.push(
            this.chartInstanceService.select.subscribe(c => {
                if (c !== this) {
                    this._isSelected = false;
                }
            })
        );
        this.subscribtions.push(
            this._showSpaceAfterDataService.subscriber.subscribe(t => {
                if (t != this.showSpaceAfterData) {
                    this.showSpaceAfterData = t;
                    this.chart.selectRange(
                        this.maxRangeValue - this.selectionRange * this.periodValue,
                        this.maxRangeValue
                    );
                }
            })
        );
        this.subscribtions.push(
            this.globaGridMode.lockAllCharsSubscriber.subscribe(v => {
                this._lockAllCharts = v;
            })
        );
        this.subscribtions.push(
            this.globaGridMode.isSelectedChart.subscribe(v => {
                this.isSelectedAnyChart = v;
            })
        );
        this.subscribtions.push(
            this.globaGridMode.subscribeSymbolChanged(v => {

                if( this.dataService.currentlyChanged!=this.itemID && !this.workspace.lockAllCharts)
                {
                    return;
                };
                
                if (this._lastChangedSymbol != v.symbol && v.symbol !== undefined && v.symbol != null) {
                    this._lastChangedSymbol = v.symbol;
                    if (this._lockAllCharts == true || v.overrideLockAllCharts == true) {
                        this.symbol = this._lastChangedSymbol;
                        this.onSelectNewSymbol(this._lastChangedSymbol, v.overrideLockAllCharts);
                    }

                    if (this._lockAllCharts == false) {
                        if (!this.isSelectedAnyChart) {
                            if (this.itemID == "ach1") {
                                this.isSelected = true;
                            }
                        }

                        if (this.isSelected) {
                            this.onSelectNewSymbol(this._lastChangedSymbol, false);
                        }
                    }
                }

                if (v.refreshperiod == true) {
                    this.onSelectNewSymbol(v.symbol, false, true);
                }
            })
        );
        this.subscribtions.push(
            this.globaGridMode.showtradeLinesSubscriber.subscribe(v => {
                this.tradeLinesVisibilityService.drawActiveState();
            })
        );
        this.subscribtions.push(
            this.globaGridMode.showIndicatorLinesSubscriber.subscribe(v => {
                this.indicatorLineThickness = v ? 1 : 0;

                this.indicatorDecors.forEach((Decor: any) => {
                    Decor.stroke("Black", this.indicatorLineThickness);
                    Decor.label().format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");
                });
            })
        );
        this.subscribtions.push(
            this.wakeUp.wakeUpSubscriber.subscribe(() => {
                setTimeout(() => {
                    // reaload current symbol/period after wakeup
                    
                    this.refreshPeriod();
                    this.tradeLinesVisibilityService.removeLines()
                   
                }, 1000); // after 1 sec
            })
        );
        this.subscribtions.push(
            this.globaGridMode.activePicker.subscribe(v => {
                if (this.itemID != v) {
                    this.hideColorPicker();
                }
            })
        );
    }

    private UnsubscribeAll() {
        this.subscribtions.forEach(x => x.unsubscribe());
    }

    public get showtradeLines(): boolean {
        return this.workspace.showtradeLines;
    }

    private _showLinesOnCurrentChart: boolean = true;

    public get showLinesOnCurrentChart(): boolean {
        if (this.workspace.mobileMode != "desktop") {
            return this.workspace.showtradeLines;
        }

        return this.tradeLinesVisibilityService.showTradeLines[this.itemID];
    }

    public set showLinesOnCurrentChart(value: boolean) {
        if (this.workspace.mobileMode != "desktop") {
            this.workspace.showtradeLines = value;
        }

        this.tradeLinesVisibilityService.showTradeLines[this.itemID] = value;
        this._showLinesOnCurrentChart = value;
    }

    public showLinesOnCurrentChartAction() {
        this.showLinesOnCurrentChart = !this.showLinesOnCurrentChart;

        this.tradeLinesVisibilityService.drawActiveState();
        if(!this.showtradeLines)
        {
            return;
        }

        //   this.showSupportLines();
        if (this.workspace.mobileMode != "desktop") {
            return;
        }

        
    }

    public updateChartDisplay(currentDisplay: ChartDisplayMode): Promise<any> {
        return new Promise<any>((rs, rj) => {
            setTimeout(() => {
                if (this.workspace.charts[this.itemID].instance) {
                    (window as any)._runOutsideAngular = true;
                    this.chart.enabled(false);
                    //this.chart.splitters().enabled(false);
                    this._inChartAutoRedrawAfterAction++;
                    this.chart.autoRedraw(false);
                    this.resetAllChartElements()
                        .then(() => {
                            this._inChartAutoRedrawAfterAction = 0;
                            this.chart.enabled(true);
                            this.chart.autoRedraw(true);
                            this.chart.enabled(false);
                            this._inChartAutoRedrawAfterAction++;
                            switch (currentDisplay) {
                                case ChartDisplayMode.CHARTING:
                                    this.chart.enabled(true);
                                    this._inChartAutoRedrawAfterAction = 0;
                                    this.chart.autoRedraw(true);
                                    this.drawCharting()
                                        .then(() => {
                                            this.afterDisplayModeChartDraw()
                                                .then(() => {
                                                    this.setBackgroundColor(this.Config.BackgroundColor);
                                                    this.setChartFontColor(this.Config.FontColor);
                                                    this.setChartAxisColor(this.Config.AxisColor);
                                                    this.CrosshairColor = this.Config.CrosshairColor;
                                                    rs();
                                                })
                                                .catch(e => {
                                                    console.error(e);
                                                });
                                        })
                                        .catch(e => {
                                            console.error(e);
                                        });
                                    break;
                                case ChartDisplayMode.WIZARD:
                                    this.chart.enabled(true);
                                    this.chart.autoRedraw(true);
                                    this.resetChartDisplay().then(() => {
                                        this.drawWizard()
                                            .then(() => {
                                                this.afterDisplayModeChartDraw()
                                                    .then(() => {
                                                        rs();
                                                    })
                                                    .catch(e => {
                                                        console.error(e);
                                                    });
                                            })
                                            .catch(e => {
                                                console.error(e);
                                            });
                                    });
                                    break;

                                case ChartDisplayMode.ENTSIGNALS:
                                    this.drawEntrySignals();
                                    this.hidePreloader();
                                    this.loadAnnotations();
                                    this.drawTitle();
                                    this.drawIndicatorTab();

                                    let dt = darkTheme();
                                    this.setChartFontColor(dt.defaultFontSettings.fontColor);
                                    this.setChartAxisColor(dt.defaultAxis.stroke);

                                    this.workspace.save();

                                //    this.tradeLinesVisibilityService.drawActiveState();

                                    (window as any)._runOutsideAngular = false;
                                    this.chart.enabled(true);
                                    this.chart.autoRedraw(true);
                                    this._inChartAutoRedrawAfterAction--;
                                    rs();
                                    break;
                            }
                        })
                        .catch(e => {
                            console.error(`${this.itemID}: ${e}`);
                            rj(e);
                        });
                } else {
                    rs();
                }
            }, 50);
        });
    }

    private afterDisplayModeChartDraw(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.chart.enabled(false);
            this.chart.autoRedraw(false);
            this.precomputeEma(this.dataTable, this._periodsMaxTime)
                .then(() => {
                    this.hidePreloader();
                    if (this._indicatorLoaded) {
                        this.showIndicators(this.indicatorInstances)
                            .then(() => {
                                this.afterShowIndocatorsOnChart()
                                    .then(() => {
                                        rs();
                                    })
                                    .catch(e => {
                                        console.error(e);
                                    });
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    } else {
                        this.afterShowIndocatorsOnChart()
                            .then(() => {
                                rs();
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }).catch(e => {
            console.error(e);
        });
    }

    private afterShowIndocatorsOnChart(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.loadAnnotations();
            this.drawTitle();
            this.drawIndicatorTab();
            let dt = darkTheme();
            this.setChartFontColor(dt.defaultFontSettings.fontColor);
            this.setChartAxisColor(dt.defaultAxis.stroke);
            this.workspace.save();

         //   this.tradeLinesVisibilityService.drawActiveState();

            this.showSupportLines()
                .then(() => {
                    (window as any)._runOutsideAngular = false;
                    this.chart.enabled(true);
                    this.chart.autoRedraw(true);
                    this._inChartAutoRedrawAfterAction--;
                    rs();
                })
                .catch(e => {
                    console.error(e);
                });
        });
    }

    public resetAllDataTables() {
        this.dataEntry.remove();
        this.dataTable.remove();
        this.dataTableEntry.remove();
        this.dataTableHidden.remove();
        this.dataTableResistance.remove();
        this.dataTableWiz.remove();
    }

    public resetAllChartElements(): Promise<any> {
        return new Promise<any>((rs, rj) => {
            this.hideAnnotations()
                .then(() => {
                    if (this.support2) this.support2.enabled(false);
                    if (this.support1) this.support1.enabled(false);
                    if (this.resistance1) this.resistance1.enabled(false);
                    if (this.resistance2) this.resistance2.enabled(false);

                    this.hideIndicators(this.Config.chartIndicatorInstances);
                    this.hideIndicators(this.Config.wizardIndicatorInstances);

                    this.resetChartDisplay()
                        .then(() => {
                            rs();
                        })
                        .catch(e => {
                            console.error(e);
                        });
                })
                .catch(e => {
                    console.error(e);
                });
        });
    }

    private async resetChartDisplay() {
        this.ChartAutoRedrawAfterAction(() => {
            this.debug("CHART_2");
            this.chart.background(darkTheme().defaultBackground.fill);

            // this.plot()
            //     .xMinorGrid()
            //     .fill(darkTheme().defaultBackground.fill);

            // entry signals
            this.entryDisplay = false;
            if (this.emaFirst != null && this.emaSecond != null) {
                this.emaSecond.enabled(false);
                this.emaFirst.enabled(false);
                this.plot().removeSeriesAt(this.emaFirst.getIndex());
                this.plot().removeSeriesAt(this.emaSecond.getIndex());
                this.emaSecond.dispose();
                this.emaFirst.dispose();
                this.emaSecond = null;
                this.emaFirst = null;
            }

            // wizard

            try {
                if (this.mmaSecond) {
                    this.mmaSecond.enabled(false);
                }
                if (this.mmaFirst) {
                    this.mmaFirst.enabled(false);
                }

                //   this.candleStickSerie.tooltip(false);
                if (this.candleStickSerie) this.candleStickSerie.enabled(false);
                if (this.ohclSerie) this.ohclSerie.enabled(false);
                if (this.lineSerie) {
                    this.lineSerie.enabled(false);
                    this.lineSerie.markers(false);
                }
            } catch (e) {
                console.error(e);
            }
        });
    }

    public getmmaState() {
        return this.mmaSecond.enabled();
    }

    private _prevAddedPoint: number[] = [0, 0, 0, 0, 0];
    private _periodUpdateCatche: IPeriodsUpdate[] = [];
    private _lastPeriodUpdate: number = 0;

    private updateLastPeriod(P: IPeriodsUpdate[]): Promise<void> {
        return new Promise<void>((rs, rj) => {
            P.forEach(element => {
                this._periodUpdateCatche = this._periodUpdateCatche.filter(
                    x =>
                        x.Period.t != element.Period.t &&
                        x.PeriodType != element.PeriodType &&
                        x.Symbol != element.Symbol
                );
                this._periodUpdateCatche.push(element);
            });

            var diff = Date.now() - this._lastPeriodUpdate;
            var throttling = Number(this.workspace.appSettings.ChartPeriodThrottlingInSec || 0);
            if (throttling > 0) {
                if (diff < throttling * 1000) {
                    rs();
                    return;
                }
            }

            P = [];
            P = P.concat(this._periodUpdateCatche);
            this._periodUpdateCatche = [];
            this._lastPeriodUpdate = Date.now();

            if (!this.chartDragging) {
                this.ChartAutoRedrawAfterAction(() => {
                    this.debug("CHART_3");
                    P.forEach(periodPoint => {
                        let time = periodPoint.Period.t * PERIOD_TIMESTAMP_MULTIPLIER; //TODO: update max time
                        let lastQuoteData = [
                            time,
                            periodPoint.Period.o,
                            periodPoint.Period.h,
                            periodPoint.Period.l,
                            periodPoint.Period.c,
                            periodPoint.Period.v,
                            0
                        ];

                        // if (this.itemID == "ach1") {
                        //     console.log(
                        //         `this._lastQuoteData=[ ${new Date(lastQuoteData[0])} ;${lastQuoteData[0]}, ${
                        //             lastQuoteData[1]
                        //         }, ${lastQuoteData[2]}, ${lastQuoteData[3]}, ${lastQuoteData[4]}, ${lastQuoteData[5]}]`
                        //     );
                        // }

                        this.dataTableWiz.remove(this._prevAddedPoint[0], lastQuoteData[0] + 20 * this.periodValue);

                        this._prevAddedPoint[0] = lastQuoteData[0];
                        this._prevAddedPoint[1] = lastQuoteData[1];
                        this._prevAddedPoint[2] = lastQuoteData[2];
                        this._prevAddedPoint[3] = lastQuoteData[3];
                        this._prevAddedPoint[4] = lastQuoteData[4];

                        this.dataTable.addData([lastQuoteData]);

                        this._loadedDataMax = lastQuoteData[0];

                        if (this.mapMatcher[this.mapMatcher.length - 1] != lastQuoteData[0]) {
                            this.mapMatcher[this.mapMatcher.length] = lastQuoteData[0];
                        }

                        this.dataEntry.addData([lastQuoteData], false);

                        this.dataTableWiz.addData([lastQuoteData], false);

                        let tmp = lastQuoteData[0] + this.periodValue;
                        let dataWiz: number[][] = [];
                        var wizardEnd = lastQuoteData[0] + 20 * this.periodValue;

                        if (this.workspace.addPointsForWzard) {
                            while (tmp < wizardEnd) {
                                dataWiz.push([
                                    tmp,
                                    lastQuoteData[1],
                                    lastQuoteData[2],
                                    lastQuoteData[3],
                                    lastQuoteData[4],
                                    lastQuoteData[5],
                                    lastQuoteData[6]
                                ]);
                                tmp += this.periodValue;
                            }
                        }

                        this.dataTableWiz.addData(dataWiz);
                        // this.dataTableHidden.addData(dataHidden);

                        /*ISTHERE*/
                        this.computeAndSetSupportLines();

                        if (this.Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                            setTimeout(() => {
                                this.dataService.tryToGetFromCache(this.symbol, this.period, 1000).then(r => {
                                    var Periods: IHistoryItem[] = [];
                                    Periods = Periods.concat(r.Periods || []);

                                    let data: number[][] = (Periods || []).map(element => {
                                        // candlestick point data
                                        // [0] - data/time
                                        // [1] - open
                                        // [2] - high
                                        // [3] - low
                                        // [4] - close
                                        // [5] - volume
                                        // [6] - spot
                                        return [
                                            element.t * PERIOD_TIMESTAMP_MULTIPLIER,
                                            element.o,
                                            element.h,
                                            element.l,
                                            element.c,
                                            element.v,
                                            0
                                        ];
                                    });

                                    let dataEntry: number[][] = [];
                                    dataEntry = dataEntry.concat(data);

                                    data = data.reverse();

                                   

                                    this.dataEntry.addData(data);
                                    
                                   
                                    this.updateSignals(this.dataEntry, this._periodsMaxTime);
                                    this.drawEmas();
                                });
                            }, 500);
                        } else {
                            this.precomputeEma(this.dataEntry, this._periodsMaxTime);
                        }
                    });
                    if (this.workspace.appSettings.PriceIndicatorFromPeriod) {
                        if (P.length > 0) {
                            this.updateAskIndicator(P[P.length - 1].Period.c, this.lastPriceIndicatorUp);
                        }
                    }
                }).then(() => {
                    rs();
                });
            } else {
                setTimeout(() => {
                    this.updateLastPeriod(P)
                        .then(() => {
                            rs();
                        })
                        .catch(e => {
                            console.error(e);
                        });
                }, 100);
            }
        });
    }
  //  public lastTick;
    public updateAskIndicator(val: number, up: boolean): Promise<any> {
        return new Promise<any>((rs, rj) => {
            this.lastAsk = val;
            this.ChartAutoRedrawAfterAction(() => {
                this.debug("CHART_4");
                this.dataTableResistance.addData(
                    [[this._lastZ, this.lastS1, this.lastS2, this.lastR1, this.lastR2, this.lastAsk, 0]],
                    true
                );
                this.computeAndSetSupportLines()
                    .then(() => {
                        this.priceIndicatorUp = up;

                        if (this.priceIndicator.label() != null)
                            this.priceIndicator.label().format(String(this.lastAsk));

                        rs();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            });
        });
    }

    private createChart(): void {
        console.log(`${this.itemID} createChart`);
        this.zone.runOutsideAngular(() => {
            (window as any)._runOutsideAngular = true;
            if (this.chart) {
                (<any>this.chart).dispose();
                (<any>this.chart) = null;
                $(this.container!.nativeElement).empty();
            }
            anychartDark();

            this.chart = anychart.stock();
            // this.chart.splitters().enabled(false);
            this.initSeries();

            this.setBasicChartSettings();

            let dt = darkTheme();
            this.setChartFontColor(dt.defaultFontSettings.fontColor);
            this.setChartAxisColor(dt.defaultAxis.stroke);

            this.setBackgroundColor(dt.defaultBackground.fill);
            this.CrosshairColor = this.Config.CrosshairColor;
            this.chart.container(this.container!.nativeElement);

            this.chart.draw(true);
            this.hideCredits();

            (window as any)._runOutsideAngular = false;
            this.showPriceIndicators = true;
        });
    }

    private initSeries() {
        this.ohlcBidAskSpotSerie = this.plot().ohlc(this.ohlcResistanceMapping);

        this.ohlcBidAskSpotSerie.enabled(false);

        this.candleStickSerie = this.plot().candlestick(this.ohlcMapping);
        (this.candleStickSerie as any).connectMissingPoints(true);

        this.lineSerie = this.plot().line(this.lineMapping);

        (this.lineSerie as any).connectMissingPoints(true);

        this.ohclSerie = this.plot().ohlc(this.ohlcMapping);
        (this.ohclSerie as any).connectMissingPoints(true);

        this.ohlcBidAskSpotSerie.tooltip(false);

        this.candleStickSerie.name(this.symbol);
        this.lineSerie.name(this.symbol);
        this.ohclSerie.name(this.symbol);

        this.candleStickSerieEnabled = this.chartSerieType === StockSeriesType.CANDLESTICK;
        this.ohclSerieEnabled = this.chartSerieType === StockSeriesType.OHLC;
        this.lineSerieEnabled =
            this.chartSerieType === StockSeriesType.LINE || this.chartSerieType === StockSeriesType.PRICEPOINTLINE;
        this.lineSerie.markers(this.chartSerieType === StockSeriesType.PRICEPOINTLINE);

        // this.chart.plot().removeSeriesAt(0);
    }

    private setBasicChartSettings(): void {
        // enable Y grid
        //  this.plot().yGrid();

        // enable Y minor grid
        //v this.plot().yMinorGrid();

        // enble X grid
        this.plot().xGrid();

        // enble X minor grid
        this.plot().xMinorGrid();

        // left/right
        this.plot()
            .yAxis()
            .orientation("right");

        this.plot()
            .yAxis(1)
            .orientation("left");

        this.plot()
            .yAxis()
            .labels()
            .format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");

        // top/right/bottom/left
        this.chart.padding(5, 55, 5, 5);

        this._priceIndicator = this.plot().priceIndicator(0);
        this.priceIndicator.series(this.ohlcBidAskSpotSerie);
        this.priceIndicator.valueField("volume");
        this.priceIndicator.value("series-end");
        this.priceIndicator.zIndex(10000);
        this.priceIndicatorUp = true;

        // update range on data change
        this.chart.preserveSelectedRangeOnDataUpdate(false);
        ///this.chart.xScale(anychart.scales.dateTime());
        // 'ordinal');
        this.chartInstanceService.select.next(this);

        this.chart.listen("chartDraw", () => {
            this.hideCredits();
            this.drawTitle();
        });

        this.chart.listen(EventType.ANNOTATION_CHANGE, (e: any) => {
            this.tradingLines.forEach(v => {
                v.allowRemove = false;
            });
        });

        this.chart.listen(EventType.ANNOTATION_CHANGE_FINISH, (e: any) => {
            //  try {

            this.tradingLines.forEach(v => {
                if (e.annotation == v.marketStopLine || e.annotation == v.marketLimitLine) {
                    //debugger;

                    v.updateOrderEntry(e.annotation.valueAnchor().toFixed(this.Decimal));
                }
                v.allowRemove = true;
                // this.drawTradeLinesAction();
            });

            //    } catch (e) {

            //    }

            this.saveAnnotations();
            this.decorateAnnotation(e.annotation);
        });

        this.chart.listen(EventType.ANNOTATION_UNSELECT, (e: any) => {
            this.saveAnnotations();
        });

        this.chart.listen(EventType.ANNOTATION_DRAWING_FINISH, (e: any) => {
            this.saveAnnotations();
        });

        //  this.chart.listen(EventType.ANNOTATION_CHANGE_START, e => );

        (<any>this.chart).achartComponent = this;
        this.chart.scroller();
        this.chart.scroller().allowRangeChange(true);
        this.chart.scroller().maxHeight(20);

        // this.chart.listen(EventType.CONNECTOR_DBL_CLICK, e => {

        // });

        // this.chart.listen(EventType.EVENT_MARKER_DBLCLICK, e => {

        // });

        this.chart.listen("dblClick", e => {
            this.chartDbClick();
        });

        // this.chart.listen(EventType.ANNOTATION_DRAWING_FINISH, e => {

        // });

        this.chart.listen(EventType.SELECTED_RANGE_BEFORE_CHANGE, e => {
            if ((<any>e).firstSelected < this.minRangeValue) {
                this.zone.runOutsideAngular(() => {
                    this.chart.selectRange(
                        this.minRangeValue,
                        //this.minRangeValue + this.selectionRange * this.periodValue
                        this.mapMatcher.length >= this.selectionRange
                            ? this.mapMatcher[this.selectionRange - 1]
                            : this.maxRangeValue
                    );
                });
                return false;
            }
            if ((<any>e).lastSelected > this.maxRangeValue) {
                this.zone.runOutsideAngular(() => {
                    this.chart.selectRange(
                        //this.maxRangeValue - this.selectionRange * this.periodValue,
                        this.mapMatcher.length >= this.selectionRange
                            ? this.mapMatcher[this.mapMatcher.length - this.selectionRange]
                            : this.mapMatcher[0],
                        this.maxRangeValue
                    );
                });
                return false;
            } else return true;
        });

        this.chart.listen(EventType.SELECTED_RANGE_CHANGE_START, e => {
            this.chartDragging = true;
        });

        // this.chart.listen(EventType.SELECTED_RANGE_CHANGE, e => {

        // });

        this.chart.listen(EventType.SELECTED_RANGE_CHANGE_FINISH, e => {
            this.chartDragging = false;
            if ((<any>e).source != "scroller-drag") {
                let tmp = 0;
                this.mapMatcher.forEach(
                    x => (tmp += x >= (<any>e).firstSelected && x <= (<any>e).lastSelected ? 1 : 0)
                );
                this.selectionRange = tmp; //Math.abs((<any>e).firstSelected-(<any>e).lastSelected)/this.periodValue;
            }
        });

        this.chart.listen("MouseMove", (e: any) => {
            this.decorateAnnotation(this.chart.annotations().getSelectedAnnotation());
        });

        this.plot()
            .legend()
            .enabled(false)
            .paginator(false)
            .height(0);
        this.chart.tooltip(false);
        this.chart.tooltip().positionMode("chart");
        this.chart.tooltip().anchor("left-top");
        this.chart.tooltip().position("left-top");
        this.chart.tooltip().offsetY(10);
        this.chart.tooltip().offsetX(10);
        //  this.chart.tooltip().format("{%seriesName}: {%value}{groupsSeparator:', decimalsCount:13}");
        formatcrosshairLabel(this);
        this.CrosshairColor = this.Config.CrosshairColor;

        this.chart.contextMenu(false);

        this._lastChangedSymbol = this.symbol;
    }

    public defaultChartMenuItems() {
        let items: MenuItem[] = [];
        if (this.workspace.chartDisplayMode != ChartDisplayMode.ENTSIGNALS) {
            items.push(
                new MenuItem(
                    "Support & Resistance",
                    () => this.showSRLines(),
                    undefined,
                    `ac ${this.showResistanceLines ? "ac-check-thin" : ""}`
                )
            );
            items.push(
                new MenuItem(
                    "Show Trades On Chart",
                    () => this.showLinesOnCurrentChartAction(),
                    undefined,
                    `ac ${this.showLinesOnCurrentChart ? "ac-check-thin" : ""}`
                )
            );
            if (this.workspace.indicators) {
                let groups = this.workspace.indicators.indicators.indicator
                    .map(i => i.group)
                    .filter((group, index, array) => array.indexOf(group) == index);

                items.push(
                    ...this.workspace.indicators.indicators.indicator
                        .filter(i => i.group === undefined)
                        .map(i => this.getIndicatorMenuItem(i))
                );
                items.push(new MenuItem());
                groups.forEach(group => {
                    if (this.workspace.indicators == undefined) return;

                    if (group == undefined) return;

                    items.push(
                        new MenuItem(
                            group.charAt(0).toUpperCase() + group.slice(1),
                            undefined,
                            this.workspace.indicators.indicators.indicator
                                .filter(i => i.group == group)
                                .map(i => this.getIndicatorMenuItem(i))
                        )
                    );
                    items.push(new MenuItem());
                });
            }

            items.push(
                new MenuItem(
                    "User strategies",
                    () => {
                        this.workspace
                            .loadUserIndicatorsSet()
                            .then(response => {
                                ShowSavedStrategiesModal([this], this.modalService, this.workspace.mobileMode);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    },
                    undefined,
                    "ac ac-charts-many"
                )
            );
            items.push(
                new MenuItem(
                    "Remove all indicators",
                    () => {
                        Object.keys(this.indicatorInstances).forEach(key => {
                            while ((this.indicatorInstances[key] || []).length > 0) {
                                this.indicatorInstances[key] = this.DeleteIndicatorInstance(
                                    this.indicatorInstances[key][0],
                                    0,
                                    this.indicatorInstances[key]
                                );
                            }
                        });
                        this.saveUserIndicators();
                        this.workspace.charts[this.itemID].setHasChanges(true);
                        this.workspace.save();
                        this.drawIndicatorTab();
                        this.contextMenuService.hide();
                    },
                    undefined,
                    "ac ac-trash-o"
                )
            );
            items.push(new MenuItem());
            items.push(
                new MenuItem(
                    "Remove selected annotation",
                    () => {
                        this.contextMenuService.hide();
                        this.removeSelectedAnnotation();
                        this.saveAnnotations();
                    },
                    undefined,
                    "ac ac-remove2-thin"
                )
            );
            items.push(
                new MenuItem(
                    "Remove all annotations",
                    () => {
                        this.getAnnotations(this.plot()).forEach(a => this.undecorateAnnotation(a));
                        this.plot()
                            .annotations()
                            .removeAllAnnotations();
                        this.saveAnnotations();
                        this.contextMenuService.hide();
                    },
                    undefined,
                    "ac ac-trash-o"
                )
            );
            items.push(new MenuItem());
        }

        items.push(new MenuItem("Enter full screen", () => {}));
        items.push(new MenuItem("Start zoom marquee", () => {}));
        items.push(new MenuItem("Remove annotations", () => {}));
        if (this.workspace.chartDisplayMode == ChartDisplayMode.CHARTING) {
            items.push(
                new MenuItem(
                    "Chart options",
                    () => ShowTemplatesModal(this.modalService, [this], this.workspace.mobileMode) && false,
                    undefined,
                    "ac ac-cog"
                )
            );
        }
        return items;
    }

    public isLineAnnotation(annotation: anychart.core.annotations.Base) {
        const annotationType = annotation.getType().toLowerCase();
        return annotationType.indexOf("line") != -1 || annotationType == "ray";
    }

    public getDistanceToLineAnnotation(
        annotation: anychart.core.annotations.Base,
        fromPosition: Position2D,
        valueIfUndefined = Number.MAX_SAFE_INTEGER
    ) {
        if (this.container == undefined) return valueIfUndefined;

        const chartSvgElement = this.container.nativeElement.querySelector("svg") as SVGElement;
        const chartRect = chartSvgElement.getBoundingClientRect();
        const chartPosition = { x: chartRect.left, y: chartRect.top };
        const annotationType = annotation.getType().toLowerCase();
        const annotationAny = annotation as any;
        const lineThickness = annotationAny.stroke().thickness as number;

        const firstPoint: Position2D = {
            x: chartPosition.x + annotationAny.coords.xAnchor,
            y: chartPosition.y + annotationAny.coords.valueAnchor
        };
        const secondPoint: Position2D = {
            x: chartPosition.x + annotationAny.coords.secondXAnchor,
            y: chartPosition.y + annotationAny.coords.secondValueAnchor
        };
        switch (annotationType) {
            case "horizontal-line":
                return Math.abs(firstPoint.y - fromPosition.y) - lineThickness;
            case "vertical-line":
                return Math.abs(firstPoint.x - fromPosition.x) - lineThickness;
            case "infinite-line":
                return Utils.distToLine(fromPosition, firstPoint, secondPoint) - lineThickness;
            case "ray":
                if (
                    (firstPoint.x < secondPoint.x && fromPosition.x < firstPoint.x) ||
                    (firstPoint.x > secondPoint.x && fromPosition.x > firstPoint.x) ||
                    (firstPoint.y < secondPoint.y && fromPosition.y < firstPoint.y) ||
                    (firstPoint.y > secondPoint.y && fromPosition.y > firstPoint.y)
                )
                    return Utils.distToSegment(fromPosition, firstPoint, secondPoint) - lineThickness;
                return Utils.distToLine(fromPosition, firstPoint, secondPoint) - lineThickness;
            case "line":
                return Utils.distToSegment(fromPosition, firstPoint, secondPoint) - lineThickness;
        }
        return valueIfUndefined;
    }

    public getLineAnnotationsSortedByDistance(fromPosition: Position2D) {
        try {
            return this.getAnnotations(this.plot())
                .filter(a => this.isLineAnnotation(a) && a.allowEdit())
                .map(a => ({
                    annotation: a,
                    distanceToClick: this.getDistanceToLineAnnotation(a, fromPosition) || Number.MAX_SAFE_INTEGER
                }))
                .sort((a, b) =>
                    a.distanceToClick > b.distanceToClick ? 1 : b.distanceToClick > a.distanceToClick ? -1 : 0
                );
        } catch (e) {
            console.error({ info: "[achart->getLineAnnotationsSortedByDistance] Caught exception", exception: e });
        }
        return undefined;
    }

    public getClosestLineAnnotation(fromPosition: Position2D) {
        const lineAnnotations = this.getLineAnnotationsSortedByDistance(fromPosition);

        if (lineAnnotations == undefined || lineAnnotations.length < 1) return undefined;

        return lineAnnotations[0];
    }

    lineAnnotationClickMaxDistance = 4;
    public getClickedLineAnnotation(clickPosition: Position2D) {
        const closestAnnotation = this.getClosestLineAnnotation(clickPosition);

        if (!closestAnnotation) return undefined;

        if (closestAnnotation.distanceToClick > this.lineAnnotationClickMaxDistance) return undefined;

        return closestAnnotation;
    }

    cloneLineAnnotation(annotation: anychart.core.annotations.Base) {
        const newAnnotation = this.getNewLineAnnotationOfSameType(annotation);
        if (newAnnotation == undefined) return;
        const annotationAny = annotation as any;
        const newAnnotationAny = newAnnotation as any;
        const stroke = annotationAny.stroke();
        const baseZIndex = annotation.zIndex() || 0;
        const newAnnotationZIndex = baseZIndex + 1;

        if (newAnnotationAny.xAnchor) newAnnotationAny.xAnchor(annotationAny.xAnchor());
        if (newAnnotationAny.valueAnchor) newAnnotationAny.valueAnchor(annotationAny.valueAnchor());
        if (newAnnotationAny.secondXAnchor) newAnnotationAny.secondXAnchor(annotationAny.secondXAnchor());
        if (newAnnotationAny.secondValueAnchor) newAnnotationAny.secondValueAnchor(annotationAny.secondValueAnchor());

        newAnnotationAny.stroke(stroke.color || "red", stroke.thickness || this.workspace.lineThickness);
        newAnnotation.zIndex(newAnnotationZIndex);

        return newAnnotation;
    }

    getNewLineAnnotationOfSameType(annotation: anychart.core.annotations.Base) {
        const plot = annotation.getPlot();
        const annotations = plot.annotations() as any;

        const creationMethod = Utils.dashToCamelCase(annotation.getType());
        if (annotations[creationMethod]) return annotations[creationMethod]() as anychart.core.annotations.Base;

        return undefined;
    }

    getCloneLineMenuItem(annotation: anychart.core.annotations.Base, menuItems: MenuItem[]) {
        return new MenuItem("Clone line", () => {
            let clonedLine: anychart.core.annotations.Base | undefined;
            try {
                clonedLine = this.cloneLineAnnotation(annotation);
            } catch (e) {
                console.error({
                    info: "[achart->getCloneLineMenuItem->MenuItem->callback] Cloning line error",
                    error: e
                });
            } finally {
                if (!clonedLine) {
                    console.error(
                        "[achart->getCloneLineMenuItem->MenuItem->callback] Problem with cloning line [achart->cloneLineAnnotation] returned undefined"
                    );
                    return;
                }

                return this.afterLineCloned(clonedLine, menuItems);
            }
        });
    }

    afterLineCloned(newAnnotation: anychart.core.annotations.Base, menuItems: MenuItem[]) {
        const hideMenuTimeout = (setTimeout(() => this.contextMenuService.hide(), 800) as any) as number;
        menuItems.length = 0;
        menuItems.push(
            new MenuItem(
                "Line cloned",
                () => {
                    clearTimeout(hideMenuTimeout);
                    this.contextMenuService.hide();
                },
                undefined,
                "ac ac-check-thin"
            )
        );
        newAnnotation.select();
        return true;
    }

    showLineAnnotationContextMenu(event: MouseEvent, annotation: anychart.core.annotations.Base) {
        try {
            const clickPosition = { x: event ? event.clientX : 0, y: event ? event.clientY : 0 };
            const menuItems = [new MenuItem("Remove line", () => this.removeAnnotation(annotation))];
            menuItems.unshift(this.getCloneLineMenuItem(annotation, menuItems));

            this.contextMenuService.show(clickPosition, menuItems, "Line annotation");
        } catch (e) {
            console.error({ info: "[achart->showLineAnnotationContextMenu] Caught exception", exception: e });
        }
    }

    public showLineAnnotationMenuIfClicked(event: MouseEvent) {
        try {
            const clickPosition = { x: event ? event.clientX : 0, y: event ? event.clientY : 0 };
            const clickedLineAnnotation = this.getClickedLineAnnotation(clickPosition);
            if (clickedLineAnnotation) {
                this.showLineAnnotationContextMenu(event, clickedLineAnnotation.annotation);
                return clickedLineAnnotation.annotation;
            }
        } catch (e) {
            console.error({ info: "[achart->getLineAnnotationsSortedByDistance] Caught exception", exception: e });
        }
        return null;
    }

    public showContextmenu(event: MouseEvent, mobileMainChartMenu: boolean = false) {
        
        this.hideColorPicker();
        callNextAsync(this.workspace.globaGridMode.activePicker, this.itemID);

        if (this.showLineAnnotationMenuIfClicked(event) != undefined) return false;

        const clickPosition = { x: event ? event.clientX : 0, y: event ? event.clientY : 0 };

        if (this.showResistanceLines) {
            if (event != null && this.getClickedSupportLine(clickPosition) != null) {
                this.showColorPicker(clickPosition);
                return false;
            }
        }

       // this.activeDisplayMode
        if (this.workspace.mobileMode != "desktop" && this.workspace.chartDisplayMode=="signals") {
            return false;
        }

        let items: MenuItem[] = [];
        if (this.workspace.chartDisplayMode != ChartDisplayMode.ENTSIGNALS) {
            items.push(
                new MenuItem(
                    "Support & Resistance",
                    () => this.showSRLines(),
                    undefined,
                    `ac ${this.showResistanceLines ? "ac-check-thin" : ""}`,
                    undefined,
                    undefined,
                    undefined,
                    true,
                    "ac ac-check-thin",
                    "ac"
                )
            );
            items.push(
                new MenuItem(
                    "Show Trades On Chart",
                    () => this.showLinesOnCurrentChartAction(),
                    undefined,
                    `ac ${this.showLinesOnCurrentChart ? "ac-check-thin" : ""}`,
                    undefined,
                    undefined,
                    undefined,
                    true,
                    "ac ac-check-thin",
                    "ac"
                )
            );
            if (this.workspace.indicators) {
                let groups = this.workspace.indicators.indicators.indicator
                    .map(i => i.group)
                    .filter((group, index, array) => array.indexOf(group) == index);

                items.push(
                    ...this.workspace.indicators.indicators.indicator
                        .filter(i => i.group === undefined)
                        .map(i => this.getIndicatorMenuItem(i))
                );
                items.push(new MenuItem());
                groups.forEach(group => {
                    if (this.workspace.indicators == undefined) return;

                    if (group == undefined) return;

                    items.push(
                        new MenuItem(
                            group.charAt(0).toUpperCase() + group.slice(1),
                            undefined,
                            this.workspace.indicators.indicators.indicator
                                .filter(i => i.group == group)
                                .map(i => this.getIndicatorMenuItem(i))
                        )
                    );
                    items.push(new MenuItem());
                });
            }

            items.push(
                new MenuItem(
                    "User strategies",
                    () => {
                        this.workspace
                            .loadUserIndicatorsSet()
                            .then(response => {
                                ShowSavedStrategiesModal([this], this.modalService, this.workspace.mobileMode);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    },
                    undefined,
                    "ac ac-charts-many"
                )
            );
            items.push(
                new MenuItem(
                    "Remove all indicators",
                    () => {
                        Object.keys(this.indicatorInstances).forEach(key => {
                            while ((this.indicatorInstances[key] || []).length > 0) {
                                this.indicatorInstances[key] = this.DeleteIndicatorInstance(
                                    this.indicatorInstances[key][0],
                                    0,
                                    this.indicatorInstances[key]
                                );
                            }
                        });
                        this.saveUserIndicators();
                        this.workspace.charts[this.itemID].setHasChanges(true);
                        this.workspace.save();
                        this.drawIndicatorTab();
                        this.contextMenuService.hide();
                    },
                    undefined,
                    "ac ac-trash-o"
                )
            );
            items.push(new MenuItem());
            items.push(
                new MenuItem(
                    "Remove selected annotation",
                    () => {
                        this.contextMenuService.hide();
                        this.removeSelectedAnnotation();
                        this.saveAnnotations();
                    },
                    undefined,
                    "ac ac-remove2-thin"
                )
            );
            items.push(
                new MenuItem(
                    "Remove all annotations",
                    () => {
                        this.getAnnotations(this.plot()).forEach(a => this.undecorateAnnotation(a));
                        this.plot()
                            .annotations()
                            .removeAllAnnotations();
                        this.saveAnnotations();
                        this.contextMenuService.hide();
                    },
                    undefined,
                    "ac ac-trash-o"
                )
            );
            items.push(new MenuItem());
        }

        items.push(new MenuItem("Enter full screen", () => {}));
        items.push(new MenuItem("Start zoom marquee", () => {}));
        items.push(new MenuItem("Remove annotations", () => {}));
        if (this.workspace.chartDisplayMode == ChartDisplayMode.CHARTING) {
            items.push(
                new MenuItem(
                    "Chart options",
                    () => ShowTemplatesModal(this.modalService, [this], this.workspace.mobileMode) && false,
                    undefined,
                    "ac ac-cog"
                )
            );
        }

        this.contextMenuService.show(
            { x: event ? event.clientX : 0, y: event ? event.clientY : 0 },
            items,
            "Indicators",
            this.workspace.mobileMode != "desktop" ? 0 : 13
        );

        return false;
    }

    colorPickerPosition?: { x: number; y: number };
    supportLinesHeightPx = 15;
    supportLinesExtraWidthPx = 55;

    showColorPicker(clickPosition: { x: number; y: number }) {
        this.contextMenuService.hide();

        const hostBoundingRect: DOMRect = this.element.nativeElement.getBoundingClientRect();
        return (this.colorPickerPosition = {
            x: clickPosition.x - hostBoundingRect.x,
            y: clickPosition.y - hostBoundingRect.y
        });
    }

    hideColorPicker() {
        this.colorPickerPosition = undefined;
    }

    getSupportLines() {
        const supportLines: anychart.core.axisMarkers.CurrentPriceIndicator[] = [];
        if (this.support1 && this.support1.enabled()) supportLines.push(this.support1);
        if (this.support2 && this.support2.enabled()) supportLines.push(this.support2);
        if (this.resistance1 && this.resistance1.enabled()) supportLines.push(this.resistance1);
        if (this.resistance2 && this.resistance2.enabled()) supportLines.push(this.resistance2);
        return supportLines;
    }

    private _lineClicked: string = "NO";
    public get lineClicked(): string {
        return this._lineClicked;
    }
    public set lineClicked(value: string) {
        this._lineClicked = value;
    }

    get userEmail() {
        return this.workspace.userName;
    }

    getClickedSupportLine(clickPosition: Position2D) {
        const supportLinesBoundingRects: {
            supportLine: any;
            boundingRect: DOMRect;
            yDistanceToCursor: number;
        }[] = this.getSupportLines().map((sl: any) => {
            const result = {
                supportLine: sl,
                boundingRect: sl.line.domElement().getBoundingClientRect(),
                yDistanceToCursor: 0
            };
            result.yDistanceToCursor = Math.abs(result.boundingRect.y - clickPosition.y);
            return result;
        });

        const supportLineClosestToCursor = supportLinesBoundingRects.sort((a, b) =>
            a.yDistanceToCursor > b.yDistanceToCursor ? 1 : b.yDistanceToCursor > a.yDistanceToCursor ? -1 : 0
        )[0];

        if (supportLineClosestToCursor.yDistanceToCursor > this.supportLinesHeightPx / 2) return null;

        if (clickPosition.x < supportLineClosestToCursor.boundingRect.x) return null;

        if (
            clickPosition.x >
            supportLineClosestToCursor.boundingRect.x +
                supportLineClosestToCursor.boundingRect.width +
                this.supportLinesExtraWidthPx
        ) {
            return null;
        }

        this.lineClicked = "TRUE " + clickPosition.x + "_" + clickPosition.y;

        return supportLineClosestToCursor.supportLine;
    }

    colorPicked(e: ColorEvent) {
        this.SupportLinesColor = e.color.hex;
    }

    removeSelectedAnnotation() {
        this.removeAnnotation(
            this.plot()
                .annotations()
                .getSelectedAnnotation()
        );
    }

    removeAnnotation(annotation: anychart.core.annotations.Base) {
        this.undecorateAnnotation(annotation);
        this.plot()
            .annotations()
            .removeAnnotation(annotation);
        this.saveAnnotations();
    }

    getPlots() {
        const plotsCount = this.chart.getPlotsCount();
        const plots = [];
        for (let i = 0; i < plotsCount; i++) {
            plots[i] = this.chart.plot(i);
        }
        return plots;
    }

    indicatorMenuItem: Map<string, MenuItem> = new Map<string, MenuItem>();

    getIndicatorMenuItemButtons(instancesCount: number) {
        return [new Button(undefined, instancesCount.toString())];
    }

    getIndicatorMenuItemSubmenu(instances: IIndicatorInstance[], indicator: IIndicator) {
        return instances.map(
            (x, index) =>
                new MenuItem(
                    `${index + 1}. ${x.title}`,
                    () => {
                        ShowIndicatorModal(this, this.workspace, x.indicator, index, this.modalService);
                    },
                    undefined,
                    undefined,
                    [
                        new Button("ac ac-trash-o on-hover", undefined, () => {
                            this.indicatorInstances[indicator.type] = this.DeleteIndicatorInstance(x, index, instances);
                            this.saveUserIndicators();
                            this.drawIndicatorTab();
                            this.workspace.save();
                        })
                    ]
                )
        );
    }

    getIndicatorMenuItem(indicator: IIndicator) {
        let submenu: MenuItem[] | undefined;
        let buttons: Button[] | undefined;
        if (this.indicatorInstances[indicator.type] && this.indicatorInstances[indicator.type].length > 0) {
            submenu = this.getIndicatorMenuItemSubmenu(this.indicatorInstances[indicator.type], indicator);
            buttons = this.getIndicatorMenuItemButtons(this.indicatorInstances[indicator.type].length);
        }

        const item = new MenuItem(
            indicator.title,
            () => ShowIndicatorModal(this, this.workspace, indicator, -1, this.modalService),
            submenu,
            "ac ac-plus on-hover",
            buttons,
            new MenuItem("Add", undefined, undefined, "ac ac-plus on-hover")
        );
        this.indicatorMenuItem.set(indicator.title, item);

        return item;
    }

    private hideCredits() {
        $(".anychart-credits").hide();
        //infosystrade.com-46c36e6a-fec38954
    }

    private _showSpaceAfterData: boolean = true;
    set showSpaceAfterData(v: boolean) {
        this._showSpaceAfterData = v;
    }

    get showSpaceAfterData(): boolean {
        return this._showSpaceAfterData;
    }

    private plot(index: number = 0) {
        return index == 0 ? this.chart.plot() : this.chart.plot(index);
    }

    private xGrid(plotIndex: number = 0, index: number = 0) {
        return index == 0 ? this.plot(plotIndex).xGrid() : this.plot(plotIndex).xGrid(index);
    }

    private tempIndex: number = -1;
    private TooltipSerie: any = null;

    private mmaFirst: any;
    private mmaSecond: any;

    drawWizard(display: boolean = true): Promise<void> {
        return new Promise<void>((rs, rj) => {
            if (!this.Config) {
                rs();
            } else {
                //this.ChartAutoRedrawAfterAction(() => {
                this.entryDisplay = false;

                this.chart.tooltip(this.Config.ShowTooltip);

                let smaT = false;
                // let seriesType = "spline"

                // if(this.workspace.addPointsForWzard==false)
                // {
                //     smaT = true;
                //     seriesType = "line"
                // }

                if (this.mmaSecond != null) {
                    this.mmaSecond.enabled(display);
                    this.mmaFirst.enabled(display);
                } else {
                    this.mmaFirst = this.plot()
                        .sma(this.lineMappingFirst, 89)
                        .series();

                    this.plot()
                        .getSeriesAt(this.mmaFirst.getIndex())
                        .tooltip(smaT);

                    this.mmaSecond = this.plot()
                        .sma(this.lineMappingSecond, 89)
                        .series();

                    this.plot()
                        .getSeriesAt(this.mmaSecond.getIndex())
                        .tooltip(smaT);

                    this.mmaFirst.seriesType("area");
                    //this.mmaFirst.zIndex(5);
                    this.mmaFirst.normal().fill(ChartColorTable.ColorWizardRed, 1);
                    this.mmaFirst.normal().stroke(ChartColorTable.ColorWizardRed, 1);

                    this.mmaSecond.seriesType("area");
                    //this.mmaSecond.zIndex(4);
                    this.mmaSecond.normal().fill(ChartColorTable.ColorWizardYellow, 1);
                    this.mmaSecond.normal().stroke(ChartColorTable.ColorWizardYellow, 1);
                }

                (this.mmaFirst as any).connectMissingPoints(true);
                (this.mmaSecond as any).connectMissingPoints(true);

                this.lineSerieEnabled = true;
                this.lineSerie.tooltip(false);

                if (this.tempIndex == -1) {
                    this.TooltipSerie = this.plot()
                        .candlestick(this.ohlcMapping)
                        .height(0)
                        .risingStroke("none")
                        .risingFill("none")
                        .fallingFill("none")
                        .fallingStroke("none");

                    this.tempIndex = this.TooltipSerie.getIndex();
                    this.plot()
                        .getSeriesAt(this.tempIndex)
                        .name(this.symbol);
                }

                this.candleStickSerieEnabled = false;

                //setTimeout(() => {
                this.chartSerieType = this.Config.WizardSerie;
                //     }, 5000);

                this.xGrid().enabled(true);
                //this.xGrid().zIndex(1);
                this.xGrid().palette([ChartColorTable.ColorWizardGreen]);
                this.xGrid().stroke(ChartColorTable.ColorWizardGreen);

                this.chart.background(darkTheme().defaultBackground.fill); // force default background
                this.plot().background(darkTheme().defaultBackground.fill);

                this.xGrid().fill(ChartColorTable.ColorWizardGreen);
                this.plot()
                    .xMinorGrid()
                    .fill(ChartColorTable.ColorWizardGreen);

                this.mmaSecond.zIndex(this.xGrid().zIndex() + 1);
                this.mmaFirst.zIndex(this.mmaSecond.zIndex() + 1);

                this.candleStickSerie.risingStroke(this.CandleStickSerieBorderColor);
                this.candleStickSerie.fallingStroke(this.CandleStickSerieBorderColor);
                this.candleStickSerie.risingFill(this.CandleStickSerieRisingColor);
                this.candleStickSerie.fallingFill(this.CandleStickSerieFallingColor);

                this.ohclSerie.fallingStroke(this.CandleStickSerieFallingColor);
                this.ohclSerie.risingStroke(this.CandleStickSerieRisingColor);

                this.showGrid = this._showGrid;

                this.lineSerie.stroke(this.WizardLineSeriesWidth + " " + this.WizardLineSeriesColor);

                this.lineSerie.markers().fill(this.WizardLineSeriesColor);
                this.mmaSecond.enabled(display);
                this.mmaFirst.enabled(display);

                //    this.ohlcBidAskSpotSerie.enabled(false);

                if (this.TooltipSerie) this.TooltipSerie.tooltip(true);

                rs();
            }
        });
    }

    private support2?: anychart.core.axisMarkers.CurrentPriceIndicator;
    private support1?: anychart.core.axisMarkers.CurrentPriceIndicator;
    private resistance1?: anychart.core.axisMarkers.CurrentPriceIndicator;
    private resistance2?: anychart.core.axisMarkers.CurrentPriceIndicator;

    private supportStroke: string = "#000000";
    private resistanceStroke: string = "#000000";

    public showSupportLines(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            if (this.showResistanceLines) {
                this.computeAndSetSupportLines()
                    .then(() => {
                        if (!this.support2) {
                            this.support2 = this.plot().priceIndicator(6);
                            this.support2.series(this.ohlcBidAskSpotSerie);
                            this.support2.valueField("open");
                            this.support2.value("series-end");
                            this.support2
                                .label()
                                .background()
                                .fill("Green");
                            this.support2.label().fontColor("White");
                        }
                        this.support2.enabled(true);
                        this.support2.stroke(this.supportStroke);

                        if (!this.support1) {
                            this.support1 = this.plot().priceIndicator(7);
                            (window as any).support1 = this.support1;
                            this.support1.series(this.ohlcBidAskSpotSerie);
                            this.support1.valueField("high");
                            this.support1.value("series-end");

                            this.support1
                                .label()
                                .background()
                                .fill("Green");

                            this.support1.label().fontColor("White");
                        }
                        this.support1.enabled(true);
                        this.support1.stroke(this.supportStroke);
                        if (!this.resistance1) {
                            this.resistance1 = this.plot().priceIndicator(8);
                            this.resistance1.series(this.ohlcBidAskSpotSerie);
                            this.resistance1.valueField("low");
                            this.resistance1.value("series-end");

                            this.resistance1
                                .label()
                                .background()
                                .fill("#e90000");
                            this.resistance1.label().fontColor("White");
                        }

                        this.resistance1.enabled(true);
                        this.resistance1.stroke(this.resistanceStroke);
                        if (!this.resistance2) {
                            this.resistance2 = this.plot().priceIndicator(9);
                            this.resistance2.series(this.ohlcBidAskSpotSerie);
                            this.resistance2.valueField("close");
                            this.resistance2.value("series-end");

                            this.resistance2
                                .label()
                                .background()
                                .fill("#e90000");
                            this.resistance2.label().fontColor("White");
                        }
                        this.resistance2.enabled(true);
                        this.resistance2.stroke(true);
                        this.applySupportLinesColor();
                        rs();
                    })
                    .catch(e => {
                        console.error(e);
                    });
            } else {
                if (this.support1) this.support1.enabled(false);
                if (this.support2) this.support2.enabled(false);
                if (this.resistance1) this.resistance1.enabled(false);
                if (this.resistance2) this.resistance2.enabled(false);
            }
            rs();
        }).catch(e => {
            console.error(e);
        });
    }

    private lastS1 = 0;
    private lastS2 = 0;
    private lastR1 = 0;
    private lastR2 = 0;
    private lastAsk = 0;
    public updateSupportLinesData(s2: number, s1: number, r1: number, r2: number, bid: number) {
        // let c = 0;
        // let dataRes: number[][] = [];
        // let tmp = this._lastZ;
        // dataRes.push([tmp, s2, s1, r1, r2, 0, 0]);
        //dataRes.push([tmp, 0.92, 0.93, 0.94, 0.95, 0, 0]);
        this.lastS1 = s1;
        this.lastS2 = s2;
        this.lastR1 = r1;
        this.lastR2 = r2;

        this.ChartAutoRedrawAfterAction(() => {
            this.debug("CHART_5");
            let formatString: string = "{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}";
            this.dataTableResistance.addData([[this._lastZ, s2, s1, r1, r2, this.lastAsk, 0]], true);
            if (this.support1 && this.support2 && this.resistance1 && this.resistance2) {
                if (this.support1 != undefined && this.support1.label() != null) {
                    this.support1.label().format(formatString);
                    this.support2.label().format(formatString);
                    this.resistance1.label().format(formatString);
                    this.resistance2.label().format(formatString);
                }
            }
        });
    }

    private _computeAndSetSupportLinesMappings: any;

    public async computeAndSetSupportLines() {
        //   this.ChartAutoRedrawAfterAction(() => {
        //mapping.addField("dt", 0);// key - DateTime
        // mapping.addField("open", 1);
        // mapping.addField("high", 2);
        // mapping.addField("low", 3);
        if (!this._computeAndSetSupportLinesMappings) {
            this._computeAndSetSupportLinesMappings = this.dataTable.mapAs();
            let mapping = <anychart.data.TableMapping>this._computeAndSetSupportLinesMappings;
            mapping.addField("dt", 0);
            mapping.addField("open", 1);
            mapping.addField("high", 2);
            mapping.addField("low", 3);
            mapping.addField("close", 4);
        }
        let mapping = <anychart.data.TableMapping>this._computeAndSetSupportLinesMappings;
        // this.ohlcMapping.iterator

        //  let endDate = Date.now();
        //    let startDate = endDate - this.periodValue * 105;

        //   var sel = mapping.createSelectable().select(startDate, endDate);//.selectAll();

        var sel = mapping.createSelectable().selectAll();

        var iter = sel.getIterator();

        let data: any[][] = [];
        let dataHigh: Number[] = [];
        let dataLow: Number[] = [];
        let dataClose: Number[] = [];

        while (iter.advance()) {
            data.push([iter.get("dt"), iter.get("open"), iter.get("high"), iter.get("low"), iter.get("close")]);

            dataHigh.push(iter.get("high"));
            dataLow.push(iter.get("low"));
            dataClose.push(iter.get("close"));
        }

        let supportValues = this.computeSupportLines(data, dataHigh, dataLow, dataClose);
        this.updateSupportLinesData(
            supportValues.s2,
            supportValues.s1,
            supportValues.r1,
            supportValues.r2,
            this.lastAsk
        );
        //      this.applySupportLinesColor()
        // xxxx this.showSupportLines();
        //  });
    }

    private computeSupportLines(data: any, dataHigh: any, dataLow: any, dataClose: any) {
        let dataHigh_100 = dataHigh.slice(-100);
        let dataLow_100 = dataLow.slice(-100);
        let dataClose_100 = dataClose.slice(-100);
        let dClose = dataClose_100[0];

        let dPRest = this.max(dataHigh_100);
        let dPSupp = this.min(dataLow_100);

        let dataHigh_10 = dataHigh.slice(-10);
        let dataLow_10 = dataLow.slice(-10);
        let dataClose_10 = dataClose.slice(-10);

        dClose = dataClose_10[0];
        let dHigh = this.max(dataHigh_10);
        let dLow = this.min(dataLow_10);

        let dPivot = (dHigh + dLow + dClose) / 3;
        let dSRest = 2 * dPivot - dLow;
        let dSSupp = 2 * dPivot - dHigh;

        let dPrimaryResistance = dSRest < dPRest ? dSRest : dPRest;
        let dSecondaryResistance = dSRest < dPRest ? dPRest : dSRest;
        let dPrimarySupport = dSSupp > dPSupp ? dSSupp : dPSupp;
        let dSecondarySupport = dSSupp > dPSupp ? dPSupp : dSSupp;

        return {
            s2: dSecondarySupport,
            s1: dPrimarySupport,
            r1: dPrimaryResistance,
            r2: dSecondaryResistance
        };
    }

    private min(array: any) {
        var min = Math.min.apply(Math, array);
        return min;
    }

    private max(array: any) {
        var max = Math.max.apply(Math, array);
        return max;
    }

    drawCharting(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            if (!this.Config) {
                rs();
            } else {
                this.chart.tooltip(this.Config.ShowTooltip);
                // this.ChartAutoRedrawAfterAction(() => {
                this.plot().background(this.BackgroundColor);

                try {
                    if (this.mmaSecond != null && this.mmaSecond !== undefined) {
                        this.mmaSecond.enabled(false);
                        this.mmaFirst.enabled(false);
                    }
                } catch (e) {
                    console.log(e);
                }
                this.entryDisplay = false;
                this.candleStickSerieEnabled = true;
                this.candleStickSerie.tooltip(false);

                this.xGrid().palette([this.BackgroundColor]);

                this.candleStickSerie.risingStroke(this.CandleStickSerieBorderColor);
                this.candleStickSerie.fallingStroke(this.CandleStickSerieBorderColor);
                this.candleStickSerie.risingFill(this.CandleStickSerieRisingColor);
                this.candleStickSerie.fallingFill(this.CandleStickSerieFallingColor);

                this.ohclSerie.fallingStroke(this.CandleStickSerieFallingColor);
                this.ohclSerie.risingStroke(this.CandleStickSerieRisingColor);

                this.lineSerie.stroke(this.LineSeriesColor);
                this.lineSerie.markers().fill(this.LineSeriesColor);

                this.showGrid = this.workspace.showPeriod;
                this.subscribtions.push(
                this.globaGridMode.subscribeShowGrid(t => {
                    this.showGrid = t;
                }))

                this.chartSerieType = this.Config.ChartingSerie;

                // this.BackgroundColor = this.Config.BackgroundColor;
                // this.FontColor = this.Config.FontColor;
                // this.AxisColor = this.Config.AxisColor;

                this.setBackgroundColor(this.Config.BackgroundColor);

                this.CrosshairColor = this.Config.CrosshairColor;
                this.setChartFontColor(this.Config.FontColor);
                this.setChartAxisColor(this.Config.AxisColor);

                rs();
            }
        });
    }

    private emaFirst: any;
    private emaSecond: any;

    public drawEntrySignals() {
        if (!this.Config) return;
        if (this.Config.DisplayMode != ChartDisplayMode.ENTSIGNALS) return;
        this.chart.tooltip(false);

        this.ChartAutoRedrawAfterAction(() => {
            this.debug("CHART_6");
            this.chartSerieType = StockSeriesType.LINE;

            this.drawEmas();

            //    }
            this.updateSignals(this.dataEntry, this._periodsMaxTime);

            if (this.TooltipSerie) this.TooltipSerie.name(this.symbol);

            if (this.resistance1) this.resistance1.enabled(false);
            if (this.resistance2) this.resistance2.enabled(false);
            if (this.support1) this.support1.enabled(false);
            if (this.support2) this.support2.enabled(false);
            this.xGrid().enabled(true);
            this.chart.background(darkTheme().defaultBackground.fill);
            this.drawIndicatorTab();
            this.entryDisplay = true;
            if (this.candleStickSerie) this.candleStickSerie.enabled(false);
            if (this.ohclSerie) this.ohclSerie.enabled(false);
            if (this.lineSerie) {
                this.lineSerie.enabled(false);
                this.lineSerie.markers(false);
            }
        });
    }

    public drawEmas() {
        if (this.Config.DisplayMode != ChartDisplayMode.ENTSIGNALS) return;
//return;
        if (this.emaFirst != null) {
            this.emaSecond.enabled(false);
            this.emaFirst.enabled(false);
            this.plot().removeSeriesAt(this.emaFirst.getIndex());
            this.plot().removeSeriesAt(this.emaSecond.getIndex());
            this.emaSecond.dispose();
            this.emaFirst.dispose();
            this.emaSecond = null;
            this.emaFirst = null;
        }
       
      
        //  if (this.emaFirst == null) {
        //   setTimeout(() => {
        this.emaFirst = drawEmaWithoutFuture(
            this.plot(),
            //    this.dataTableWiz,
            this.dataEntry,
            this.lineMappingEma,
            emaBlackPeriod,
            this._periodsMaxTime
        );

        (this.emaFirst as any).connectMissingPoints(true);

        this.emaSecond = drawEmaWithoutFuture(
            this.plot(),
            //   this.dataTableWiz,
            this.dataEntry,
            this.lineMappingEma,
            emaWhitePeriod,
            this._periodsMaxTime
        );

        (this.emaSecond as any).connectMissingPoints(true);

        this.emaFirst.normal().stroke(ChartColorTable.Black, this.WizardLineSeriesWidth);
        this.emaSecond.normal().stroke(ChartColorTable.White, this.WizardLineSeriesWidth);
        this.emaFirst.name("Black");
        this.emaSecond.name("White");
        //     },300);
    }

    public entryDisplay: boolean = false;

    private _emaVal = 0;

    public set emaVal(v: number) {
        this._emaVal = v;
    }

    public get emaVal(): number {
        return this._emaVal;
    }

    public forceBgForEma(color: string) {
        this.plot().background(darkTheme().defaultBackground.fill);
        //  this.chart.background(darkTheme().defaultBackground.fill);
        this.xGrid().fill(color);
        this.plot()
            .xMinorGrid()
            .fill(color);
    }

    public async updateSignals(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod) {
        this.zone.runOutsideAngular(() => {
            var bgG = "#26c524 0.0";
            var bgR = "#f90000 0.0";
            var bgY = "FFFF00 0.0";

            var emaData = <any>computeValueES(data, endDate, period);

            if (emaData[0] > 0) {
                this.xGrid().palette([ChartColorTable.ColorWizardGreen]);

                this.xGrid().stroke(bgG);

                this.forceBgForEma(ChartColorTable.ColorWizardGreen);
            }

            if (emaData[0] < 0) {
                this.xGrid().palette([ChartColorTable.ColorWizardRed]);
                this.xGrid().stroke(bgR);
                this.forceBgForEma(ChartColorTable.ColorWizardRed);
            }

            if (emaData[0] == 0) {
                this.xGrid().palette([ChartColorTable.Yellow]);
                this.xGrid().stroke(bgY);
                this.forceBgForEma(ChartColorTable.Yellow);
            }
            let temp = this.itemID;
            this.exactEmas = emaData;
            this.emaVal = emaData[0];
            //  this.drawEmas();
        });
    }

    public _exactEmas: any = [0, 0, 0];
    public set exactEmas(v: any) {
        this._exactEmas = v;
    }

    public get exactEmas(): any {
        return this._exactEmas;
    }

    public async precomputeEma(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod) {
        var emaData = <any>computeValueES(data, endDate, period);
        this.exactEmas = emaData;
        let temp = this.itemID;
        this.emaVal = emaData[0];
    }

    public logEmaDTABLE() {
        console.log("this.exactEmas");
        console.log(this.exactEmas);
    }

    async showPreloader() {
        if (!this._preloader) {
            this._preloader = anychart.ui.preloader();
            this._preloader!.render(this.container!.nativeElement);
            var element: HTMLDivElement = <HTMLDivElement>this.container!.nativeElement;
            var divLoader = element.querySelector("div.anychart-loader-chart-row");
            if (divLoader) {
                divLoader.innerHTML = "<img src='/css/images/PTLogo.png' width=40 height=40/>";
            }
        } else {
            this._preloader!.visible(true);
        }
    }

    async hidePreloader() {
        if (this._preloader && (<anychart.ui.Preloader>this._preloader).visible()) {
            (<anychart.ui.Preloader>this._preloader).visible(false);
        }
    }

    get chartButtonsVisible() {
        return this.Config.ChartButtonsVisible;
    }

    set chartButtonsVisible(v: boolean) {
        this.Config.ChartButtonsVisible = v;
        this.drawTitle();
    }

    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(
        value: {
            id: number;
            label: string;
            css: string;
            Order: number;
            Standard?: boolean;
            Oanda?: boolean;
        }[]
    ) {
        this.workspace.periodsList = value;
    }

    get historyPeriodLabel(): string {
        let filtered = this.periods.filter(p => p.id == this.period);
        if (filtered.length < 1) return "";
        return filtered[0].label;
    }

    private _title?: anychart.standalones.Title;

    private async drawTitle() {
        if (this.chart != undefined) {
            this._title = this._title || anychart.standalones.title();
            this._title.container(this.chart.container());
            this._title.text(`${this.symbol}  ${this.historyPeriodLabel}`);
            this._title.fontColor("white");
            this._title.fontWeight("bold");
            this._title.margin().top(
                `${this.chart
                    .plot(0)
                    .bounds()
                    .toRect()
                    .getHeight() - 60}`
            );
            var x = $(this.container!.nativeElement).width() || 0;
            this._title.margin().left(x - 210);
            this._title.margin().right(0);
            var padding = this._title.padding();
            padding.bottom(10);
            padding.right(10);
            padding.left(10);
            padding.top(10);

            var b = this._title.background();
            b.enabled(true);
            b.fill("grey 0.7");
            b.stroke("black 0.5");
            b.corners(10);
            this._title.draw();
            this._title.enabled(!this.chartButtonsVisible);
        }
    }

    public drawIndicatorTab() {
        if (
            (this.Config.DisplayMode == ChartDisplayMode.CHARTING ||
                this.Config.DisplayMode == ChartDisplayMode.WIZARD) &&
            this.indicatorInstances
        ) {
            let drawInPlot: boolean = false;
            let items: anychart.core.ui.Legend.LegendItemProvider[] = [];
            Object.keys(this.indicatorInstances).forEach(key => {
                this.indicatorInstances[key].forEach(ind => {
                    if (ind && ind.indicator && ind.indicator.defaults && ind.indicator.defaults.item) {
                        ind.indicator.defaults.item
                            .filter(item => item.name == "plotIndex")
                            .forEach(item => {
                                let plotIndex = Number(item.value);
                                if (plotIndex > 0) {
                                    let it: anychart.core.ui.Legend.LegendItemProvider = {};

                                    drawInPlot = true;
                                    //if (this.workspace.mobileMode != "desktop")
                                    {
                                        items.push({
                                            index: items.length,

                                            text: `<span>${ind.title}</span><span>&nbsp;</span>`,
                                            disabled: !(ind.enabled === true),
                                            iconType: LegendItemIconType.CIRCLE,
                                            iconFill: `${this.FontColor}`, //x ? "white" : "white 0.3",
                                            iconStroke: "4 grey 0.7",
                                            //iconMarkerType: ChartMarkerType.ArrowDown
                                            meta: ind
                                        });
                                    }
                                    // else {
                                    //     items.push({
                                    //         index: items.length,
                                    //         text: `<span>${ind.title}</span>`,
                                    //         disabled: !(ind.enabled === true),
                                    //         iconType: LegendItemIconType.CIRCLE,
                                    //         iconFill: "white", //x ? "white" : "white 0.3",
                                    //         iconStroke: "4 grey 0.7",
                                    //         //iconMarkerType: ChartMarkerType.ArrowDown
                                    //         meta: ind
                                    //     });
                                    // }

                                    // items.push({
                                    //     index: items.length,
                                    //     text: "x",
                                    //     disabled: false,
                                    //     iconType: LegendItemIconType.LINE,
                                    //     iconFill: "white 0.0", //x ? "white" : "white 0.3",
                                    //     // iconStroke: "1 grey 0.7",
                                    //     //iconMarkerType: ChartMarkerType.
                                    //     meta: ind
                                    // });

                                    this.chart
                                        .plot(2)
                                        .crosshair()
                                        .xLabel()
                                        .enabled(false);
                                }
                            });
                    }
                });
            });

            let decimals = this.Decimal;

            if (drawInPlot) {
                this.chart
                    .plot(2)
                    .legend()
                    .itemsFormat(function(e: any) {
                        let strFormatted = "";

                        strFormatted += e.seriesName;
                        if (e.value !== undefined) {
                            strFormatted += " :" + Number(e.value).toFixed(decimals);
                        }

                        let H = "";
                        if (e.high !== undefined) {
                            H = "H: " + Number(e.high).toFixed(decimals);
                        }

                        let L = "";
                        if (e.low !== undefined) {
                            L = " L: " + Number(e.low).toFixed(decimals);
                        }

                        let C = "";
                        if (e.close !== undefined) {
                            C = " C: " + Number(e.close).toFixed(decimals);
                        }

                        let O = "";
                        if (e.open !== undefined) {
                            O = " O: " + Number(e.open).toFixed(decimals);
                        }

                        if (
                            e.high !== undefined ||
                            e.low !== undefined ||
                            e.close !== undefined ||
                            e.open !== undefined
                        ) {
                            strFormatted += "(" + H + L + C + O + " )";
                        }

                        return strFormatted;
                    });
            }

            if (items.length > 0) {
                this.chart.autoRedraw(false);
                this.chart
                    .plot(1)
                    .enabled(true)
                    .maxHeight("30px")
                    .height("30px")
                    .minHeight("30px");
                this.chart
                    .plot(1)
                    .xAxis()
                    .enabled(false);
                this.chart
                    .plot(1)
                    .yAxis()
                    .enabled(false);
                this.chart
                    .plot(1)
                    .xGrid()
                    .enabled(false);
                this.chart
                    .plot(1)
                    .xMinorGrid()
                    .enabled(false);
                this.chart
                    .plot(1)
                    .yGrid()
                    .enabled(false);
                this.chart
                    .plot(1)
                    .yMinorGrid()
                    .enabled(false);
                this.forceCloseIndicator = false;
                this.chart
                    .plot(1)
                    .legend()
                    .useHtml(true)
                    .itemsSpacing(10)
                    .itemsFormatter(items => {
                        //if (this.workspace.mobileMode != "desktop")
                        {
                            items.forEach(item => {
                                (item as any)["useHtml"] = true;
                            });
                            this.forceCloseIndicator = false;
                            setTimeout(() => {
                                let element: HTMLElement = this.container!.nativeElement;
                                var tspans = element.querySelectorAll("tspan");
                                var tspansWithSpace: SVGTSpanElement[] = [];
                                tspans.forEach(ts => {
                                    if (ts.innerHTML == "&nbsp;") {
                                        tspansWithSpace.push(ts);
                                    }
                                });

                                tspansWithSpace.forEach((ts, index) => {
                                    ts.setAttribute("fill", "none");
                                    let group = ts.parentElement!.parentElement!;

                                    var texts = group.querySelectorAll("text");
                                    if (texts.length == 1) {
                                        var txt = group.ownerDocument!.createElementNS(
                                            "http://www.w3.org/2000/svg",
                                            "text"
                                        );
                                        group.appendChild(txt);
                                    }

                                    if (texts.length == 2) {
                                        var txt = texts[1];
                                        var paths = txt.parentElement!.querySelectorAll("path");
                                        var path1 = paths[1];

                                        txt.textContent = "X";

                                        txt.setAttribute("dx", `${path1.getBBox().width - 10}`);
                                        var cx = new ColorFn(this.FontColor);
                                        cx = cx.red(150);

                                        var fill = texts[0].getAttribute("fill");
                                        txt.setAttribute("fill", `rgb(${cx.red()},${cx.green()},${cx.blue()})`); //"red");
                                        var fs = texts[0].getAttribute("font-size");
                                        txt.setAttribute("font-size", fs ? fs : "12px");
                                        txt.setAttribute("font-weight", "bold");
                                        var ff = texts[0].getAttribute("font-family");
                                        txt.setAttribute("font-family", ff ? ff : "Verdana, Arial, sans-serif");
                                        var y = texts[0].getAttribute("y");
                                        txt.setAttribute("y", y ? y : "13.17");
                                        txt.style.cursor = "pointer";
                                        txt.onclick = e => {
                                            this.forceCloseIndicator = true;
                                        };
                                    }
                                });
                            }, 10);
                        }
                        return items;
                    })
                    .items(items)
                    .enabled(true)
                    .title(false)
                    .fontColor(`${this.FontColor}`)
                    .width("100%");

                this.chart
                    .plot(1)
                    .legend()
                    .fontColor("white");
                //  this._indicatorLegend.fontWeight("bold");

                let b = this.chart
                    .plot(1)
                    .legend()
                    .background();
                b.enabled(false);
                b.fill("#3E4750 0");
                b.stroke("black 0");
                b.corners(10);

                let pg = this.chart
                    .plot(1)
                    .legend()
                    .paginator();
                pg.background().fill("black 0.5");
                pg.fontColor("white");
                pg.fontWeight("bold");

                // this.chart
                //     .plot(1)
                //     .legend().items().forEach(i=>{
                //         i["userHtml"]=true;

                //     });
                // .useHtml(true)
                // .itemsFormat(item => {
                //     debugger;
                //     return "<span>xxxx</span>";
                // });

                this.chart
                    .plot(1)
                    .legend()
                    .unlisten(EventType.LEGEND_ITEM_CLICK, this.indicatorTabEvent, undefined, this);

                this.chart
                    .plot(1)
                    .legend()
                    .listen(EventType.LEGEND_ITEM_CLICK, this.indicatorTabEvent, undefined, this);

                // this._indicatorLegend.listen(EventType.LEGEND_ITEM_DBLCLICK, e => {

                // });

                // this._indicatorLegend.listen(EventType.LEGEND_ITEM_MOUSE_OUT, e => {

                // });

                // this._indicatorLegend.listen(EventType.LEGEND_ITEM_MOUSE_OVER, e => {

                // });
                this.chart.autoRedraw(true);
            } else {
                this.chart.plot(1).enabled(false);
                //       this.chart.plot(2).enabled(false);
            }
        } else {
            this.chart.plot(1).enabled(false);
            this.chart.plot(2).enabled(false);
        }
        //
    }

    private forceCloseIndicator: boolean = false;
    private indicatorTabEvent(e: any) {
        this.ChartAutoRedrawAfterAction(() => {
            this.debug("CHART_7");
            let item = this.chart
                .plot(1)
                .legend()
                .items()[(<any>e).itemIndex];
            let old = item.disabled === true;
            item.disabled = !old;
            let ind = <IIndicatorInstance>item.meta;
            ind.enabled = ind.enabled === true ? false : true;
            if (this.forceCloseIndicator) {
                this.forceCloseIndicator = false;
                setTimeout(() => {
                    var index = this.indicatorInstances[ind.indicator.type].indexOf(ind);
                    this.indicatorInstances[ind.indicator.type] = this.DeleteIndicatorInstance(
                        ind,
                        index,
                        this.indicatorInstances[ind.indicator.type]
                    );
                    this.saveUserIndicators();
                    this.drawIndicatorTab();
                    this.workspace.save();
                }, 100);
            }
            this.ShowInstance(ind);
            this.workspace.save();
        });
        return true;
    }
    public autoredrawTIemout:any;
    private _inChartAutoRedrawAfterAction: number = 0;
    async ChartAutoRedrawAfterAction(fn: () => void) {

        if(this.autoredrawTIemout)
        clearTimeout(this.autoredrawTIemout);

        if (this._inChartAutoRedrawAfterAction <= 0 && this.chart !== undefined) {
            this.debug("NOAUTOREDRAW");
            this.chart.autoRedraw(false);
        }
        this._inChartAutoRedrawAfterAction++;
        try {
            fn();
        } finally {
            this._inChartAutoRedrawAfterAction--;
        }
        if (this._inChartAutoRedrawAfterAction <= 0) {
            this._inChartAutoRedrawAfterAction = 0;
            this.autoredrawTIemout = setTimeout(() => {
                if (this._inChartAutoRedrawAfterAction <= 0) {
                    try {
                        this._inChartAutoRedrawAfterAction = 0;
                        this.chart.autoRedraw(true);
                    } catch (error) {
                          console.error(error);
                          this.debug("ERROR"); 
                    }
                }
            }, 500);
        }
    }

    private getPeriodsMaxTime(Periods: IHistoryItem[]) {
        return (this._periodsMaxTime =
            Math.max.apply(
                Math,
                Periods.map(p => p.t)
            ) * PERIOD_TIMESTAMP_MULTIPLIER);
    }

    public firstDataLoad: boolean = true;

    public sortFunction(a: any, b: any) {
        if (a[0] === b[0]) {
            return 0;
        } else {
            return a[0] < b[0] ? -1 : 1;
        }
    }

    setChartData(Periods: IHistoryItem[]): void {
        if (this.itemID == "ach1") {
            this.globaGridMode.longSymbolPeriod.next(this.period);
        }

        if (this.itemID == "ach2") {
            this.globaGridMode.midSymbolPeriod.next(this.period);
        }

        if (this.itemID == "ach3") {
            this.globaGridMode.shortSymbolPeriod.next(this.period);
        }

        if (this.itemID == "ach4") {
            this.globaGridMode.entrySymbolPeriod.next(this.period);
        }

        if (Periods && Periods.length > 0) {
            if (
                this.periodValue < getHistoryItemPeriodValue(HistoryItemPeriod.Hr24) &&
                Math.abs(Periods[0].t * PERIOD_TIMESTAMP_MULTIPLIER - Periods[1].t * PERIOD_TIMESTAMP_MULTIPLIER) >
                    this.periodValue
            ) {
                Periods = Periods.filter((v, i) => {
                    return i > 0;
                });
            }
            this.getPeriodsMaxTime(Periods);
            this.ChartAutoRedrawAfterAction(() => {
                this.debug(`CHART_8_${this.counter}`);
                this.counter==Periods.length;
                this.chart.autoRedraw(true);
                let data: number[][] = (Periods || []).map(element => {
                    // candlestick point data
                    // [0] - data/time
                    // [1] - open
                    // [2] - high
                    // [3] - low
                    // [4] - close
                    // [5] - volume
                    // [6] - spot
                    return [
                        element.t * PERIOD_TIMESTAMP_MULTIPLIER,
                        element.o,
                        element.h,
                        element.l,
                        element.c,
                        element.v,
                        0
                    ];
                });

                data.sort(this.sortFunction);

                if (data[0][0] > data[1][0]) {
                    console.log("REVERSED");
                    data = data.reverse();
                }

                if (data.length > 0) {
                    this._loadedDataMax = data[data.length - 1][0];
                    this._loadedDataMin = data[0][0];
                    this._dataLength = data.length;

                    this.mapIndexToTime = {};
                    this.mapTime = {};
                    this.mapMatcher = [];

                    data.forEach((element, index) => {
                        this.mapIndexToTime[String(element[0])] = index;
                        this.mapTime[index] = element[0];
                        this.mapMatcher[index] = element[0];
                    });

                    this.dataTable.remove();
                    this.dataEntry.remove();
                    this.dataTableWiz.remove();
                    this.dataTableHidden.remove();
                    this.dataTableResistance.remove();

                    this.dataTableEntry.remove();

                    let dataHidden: number[][] = [];

                    this._lastQuoteData = data[data.length - 1];

                    // from last value fill hidden data table
                    let tmp: number = this._lastQuoteData[0];

                    while (tmp < this._lastQuoteData[0] + 20 * this.periodValue) {
                        dataHidden.push([tmp, this._lastQuoteData[1]]);
                        tmp += this.periodValue;
                    }
                    this._lastZ = tmp;

                    let dataWiz: number[][] = [];
                    dataWiz = dataWiz.concat(data);

                    let dataEntry: number[][] = [];
                    dataEntry = dataEntry.concat(data);

                    let dataRes: number[][] = [];
                    dataRes = dataRes.concat(data);

                    tmp = this._lastQuoteData[0] + this.periodValue;

                    var wizardEnd = this._lastQuoteData[0] + 20 * this.periodValue;

                    if (this.workspace.addPointsForWzard) {
                        while (tmp < wizardEnd) {
                            dataWiz.push([
                                tmp,
                                this._lastQuoteData[1],
                                this._lastQuoteData[2],
                                this._lastQuoteData[3],
                                this._lastQuoteData[4],
                                this._lastQuoteData[5],
                                this._lastQuoteData[6]
                            ]);
                            tmp += this.periodValue;
                        }
                    }

                    this._prevAddedPoint[0] = this._lastQuoteData[0];
                    this._prevAddedPoint[1] = this._lastQuoteData[1];
                    this._prevAddedPoint[2] = this._lastQuoteData[2];
                    this._prevAddedPoint[3] = this._lastQuoteData[3];
                    this._prevAddedPoint[4] = this._lastQuoteData[4];

                    this.dataTable.addData(data);
                    this.dataEntry.addData(data);

                    this._lastPeriodUpdate = 0;
                    this._periodUpdateCatche = [];

                    this.dataTableWiz.addData(dataWiz);

                    this.dataTableResistance.addData(dataRes);

                    this.updateScroller();

                    let MaxHigh: number = Math.max.apply(
                        Math,
                        data.map(i => {
                            return i[2];
                        })
                    );

                    let MinLow: number = Math.min.apply(
                        Math,
                        data.map(i => {
                            return i[3];
                        })
                    );

                    if (
                        this._currentMaxHigh == -1 ||
                        this._currentMaxHigh < 1.01 * MaxHigh ||
                        this._currentMinLow > 0.99 * MinLow
                    ) {
                        this._currentMaxHigh = 1.01 * MaxHigh;
                        this._currentMinLow = 0.99 * MinLow;
                    }
                }

                this.showGrid = this._showGrid;

                //    this.loadAndShowIndicators();
                // if (this.tradingLines[0] != undefined) {
                //     if (
                //         this.tradingLines[0].tempTradeData != null &&
                //         this.tradingLines[0].tempTradeData.Symbol == this.symbol
                //     ) {
                //         this.tradingLines[0].backgroundColor(this.BackgroundColor);
                //         this.tradingLines[0].drawTradeLines(this.tradingLines[0].tempTradeData);
                //         // this.tradingLines[0].tempTradeData = null;
                //     }
                // }

                if (this.workspace.mobileMode != "desktop") {
                    if (this.workspace.horizontalMode) {
                        this.selectionRange = 100;
                    } else {
                        this.selectionRange = 50;
                    }
                } else {
                    this.selectionRange = 100;
                }

                if (this.emaFirst != null) {
                    this.emaSecond.enabled(false);
                    this.emaFirst.enabled(false);
                    this.plot().removeSeriesAt(this.emaFirst.getIndex());
                    this.plot().removeSeriesAt(this.emaSecond.getIndex());
                    this.emaSecond.dispose();
                    this.emaFirst.dispose();
                    this.emaSecond = null;
                    this.emaFirst = null;
                }

                setTimeout(() => {
                    this.hidePreloader();
                    let min =
                        this.mapMatcher.length >= this.selectionRange
                            ? this.mapMatcher[this.mapMatcher.length - this.selectionRange]
                            : this.mapMatcher[0];
                    let max = this.maxRangeValue;

                    this.spacer =
                        this.spacer ||
                        this.plot()
                            .ema(this.lineMappingFirst, 30)
                            .series();

                    this.drawEmas();

                    this.spacer!.normal().stroke("#ff0000", 0);

                    this.plot()
                        .getSeriesAt(this.spacer!.getIndex())
                        .tooltip(false);

                    this.chart.selectRange(min, max);

                   

                    this.redrawCharting();
                    this.drawEntrySignals();
                    console.log("SHOWTRADES")
                    this.canShowTrades = true;
                    this.tradeLinesVisibilityService.drawActiveState();
                   
                }, 500);
                this.loadAnnotations();
                if (this.firstDataLoad) {
                    this.loadAndShowIndicators();
                    this.showSupportLines();
                    //    this.applySupportLinesColor();
                    this.firstDataLoad = false;
                   
                    if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
                        this.chartSerieType = this.Config.WizardSerie;
                    } else if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
                        this.chartSerieType = this.Config.ChartingSerie;
                    }

                
                }
            });
        } else {
            this.dataTable.remove();
            this.dataEntry.remove();
            this.dataTableWiz.remove();
            this.dataTableHidden.remove();
            this.dataTableResistance.remove();
            this.hidePreloader();
        }
    }

    updateScroller() {
        if (this.chart) {
            this.chart.scroller().removeAllSeries();
            var scrollerLine = this.chart.scroller().line(this.lineMapping);
            (scrollerLine as any).connectMissingPoints(true);
        } else {
            setTimeout(() => {
                this.updateScroller();
            }, 50);
        }
    }

    public redrawCharting() {
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.xGrid().palette([this.BackgroundColor]);

            this.candleStickSerie.risingStroke(this.CandleStickSerieBorderColor);
            this.candleStickSerie.fallingStroke(this.CandleStickSerieBorderColor);
            this.candleStickSerie.risingFill(this.CandleStickSerieRisingColor);
            this.candleStickSerie.fallingFill(this.CandleStickSerieFallingColor);

            this.ohclSerie.fallingStroke(this.CandleStickSerieFallingColor);
            this.ohclSerie.risingStroke(this.CandleStickSerieRisingColor);

            this.lineSerie.stroke(this.LineSeriesColor);
            this.lineSerie.markers().fill(this.LineSeriesColor);

            this.showGrid = this._showGrid;

            this.chartSerieType = this.Config.ChartingSerie;

            this.setBackgroundColor(this.Config.BackgroundColor);

            this.CrosshairColor = this.Config.CrosshairColor;
            this.setChartFontColor(this.Config.FontColor);
            this.setChartAxisColor(this.Config.AxisColor);
        }
    }

    private spacer?: any;
    public debug(e:any)
    {
        //console.log("DEBUGNODATA", e);
        
    }
    loadChartData(period: HistoryItemPeriod, limit?: number, mark?: boolean): void {
        this.refreshPeriosCalled = true;
        if (!this.workspace.canLoadChartData) return;

       this.debug(period);

        this.zone.runOutsideAngular(() => {
            this.dataService
                .tryToGetFromCache(this.symbol, period, limit)
                .then(r => {
                    this.debug("CACHEPROCESSING");
                    var Periods: IHistoryItem[] = [];
                    Periods = Periods.concat(r.Periods || []);
                    this.ChartAutoRedrawAfterAction(() => {
                        this.debug(`CHART_9${this.counter}`);
                        this.counter==Periods.length;
                        this.setChartData(Periods); //TODO: get max time

                        this._canUpdateDataTable = true;
                        if (this.Config.DisplayMode == ChartDisplayMode.ENTSIGNALS) {
                            this.updateSignals(this.dataEntry, this._periodsMaxTime);
                        } else {
                            this.precomputeEma(this.dataEntry, this._periodsMaxTime);
                        }
                    });
                })
                .catch(er => {
                    //  console.error(er);
                    this.dataService
                        .sendHistoryRequest(this.symbol, period, limit, true)
                        .then(r => {
                            this.debug("NEWDATAPROCESSING");
                            this._currentRequestId = r;
                            if (mark == true) {
                            }
                            this._requestIdHistory.push(this._currentRequestId);
                        })
                        .catch(e => {
                            console.error(e);
                        });
                });
        });
    }

    public yScaleExtremes(min: number, max: number) {
        this.zone.runOutsideAngular(() => {
            this.plot()
                .yScale()
                .minimum(min);
            this.plot()
                .yScale()
                .maximum(max);
        });
    }

    ngOnInit(): void {
        this.dataService.visibleCharts++;
        this.showPreloader().then(() => {
            this.runChart();

            setTimeout(() => {
                this.showPreloader();
                this.updateChartDisplay(this.workspace.chartDisplayMode).then(() => {
                    if (
                        this.workspace.lockAllCharts &&
                        this.itemID != "ach1" &&
                        this.symbol != this.workspace.charts["ach1"].Symbol
                    ) {
                        this.Config.Symbol = this.workspace.charts["ach1"].Symbol;
                    }
                    this._initialized = true;
                    this.symbol = this.Config.Symbol;
                    this.refreshPeriod();
                });
            }, 50);
        });
    }

    public runChart() {
        this.zone.runOutsideAngular(() => {
            this.showPreloader();
            this.createChart();
        });

        this._lastQuoteData = [];
        this._lastQuoteData.push(Date.now());
        this._lastQuoteData.push(-1);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(1);

        this.workspace.charts[this.itemID].instance = this;
        (<any>window).charts = (<any>window).charts || [];
        (<any>window).charts[this.itemID] = this;
    }

    ngOnDestroy(): void {
        console.log("Destroyed");
        this.UnsubscribeAll();
        this.dataService.visibleCharts--;
        this.chartInstanceService.unregisterChart(this);
        this.workspace.charts[this.itemID].instance = undefined;
    }

    decorateThreeLinesAnnotation(annotation: anychart.core.annotations.Base): boolean {
        //not finished
        try {
            if (annotation == null || !Utils.objectHasValue(annotation, "threeLines")) return false;

            const annotationAny = <any>annotation;

            if (annotationAny.removed == true) return false;

            const pixelBounds = annotation.getPixelBounds();

            const plot = annotation.getPlot();
            //Get anchors before drawing finish
            const yScale = <any>annotation.yScale();
            const xScale = <any>annotation.xScale();
            const xAnchor =
                xScale.inverseTransform(
                    (annotationAny.coords.xAnchor - pixelBounds.getLeft()) / pixelBounds.getWidth()
                ) || annotationAny.xAnchor();
            const secondXAnchor =
                xScale.inverseTransform(
                    (annotationAny.coords.secondXAnchor - pixelBounds.getLeft()) / pixelBounds.getWidth()
                ) || annotationAny.secondXAnchor();
            const thirdXAnchor =
                xScale.inverseTransform(
                    (annotationAny.coords.thirdXAnchor - pixelBounds.getLeft()) / pixelBounds.getWidth()
                ) || annotationAny.thirdXAnchor();
            const valueAnchor =
                yScale.inverseTransform(
                    (pixelBounds.getBottom() - annotationAny.coords.valueAnchor) / pixelBounds.getHeight()
                ) || annotationAny.valueAnchor();
            const secondValueAnchor =
                yScale.inverseTransform(
                    (pixelBounds.getBottom() - annotationAny.coords.secondValueAnchor) / pixelBounds.getHeight()
                ) || annotationAny.secondValueAnchor();
            const thirdValueAnchor =
                yScale.inverseTransform(
                    (pixelBounds.getBottom() - annotationAny.coords.thirdValueAnchor) / pixelBounds.getHeight()
                ) || annotationAny.thirdValueAnchor();

            const firstPoint: { x: number; y: number } = { x: xAnchor, y: valueAnchor };
            const secondPoint: { x: number; y: number } = { x: secondXAnchor, y: secondValueAnchor };
            const thirdPoint: { x: number; y: number } = { x: thirdXAnchor, y: thirdValueAnchor };

            const direction = firstPoint.x > secondPoint.x ? -1 : 1;
            const startX =
                direction == -1 ? Math.max(firstPoint.x, thirdPoint.x) : Math.min(firstPoint.x, thirdPoint.x);
            const endX = startX + 5 * direction;

            const relStartX = startX - secondPoint.x;
            const secondRelStartX = startX - thirdPoint.x;
            const relEndX = endX - startX;

            const rel = { x: firstPoint.x - secondPoint.x, y: firstPoint.y - secondPoint.y };
            const yFactor = rel.y / rel.x;

            const firstY = relStartX * yFactor + secondPoint.y;
            const secondY = secondRelStartX * yFactor + thirdPoint.y;

            const startY = (firstY + secondY) / 2;
            const endY = relEndX * yFactor + startY;

            const ray: any = annotationAny.thirdLine || (annotationAny.thirdLine = plot.annotations().ray());
            Utils.objectSetValue(ray, "dontSave", true);
            ray.allowEdit(false);
            ray.xAnchor(startX);
            ray.valueAnchor(startY);
            ray.secondXAnchor(endX);
            ray.secondValueAnchor(endY);
            ray.stroke("white");
            console.log(endX);
            return true;
        } catch (e) {
            console.error(["decorateThreeLinesAnnotation error", e]);
        }
        return false;
    }

    decorateAnnotation(annotation: anychart.core.annotations.Base, index: number = -1) {
        try {
            if (annotation == null) return;

            const annotationAny = <any>annotation;

            if (annotationAny.removed == true) return;

            const coords = annotationAny.coords;
            const pixelBounds = annotation.getPixelBounds();

            if (annotation.getType() != "horizontal-line") return;

            const yScale = <any>annotation.yScale();
            const plot = annotation.getPlot();

            //this.chart.plot()
            if (this.getPlots().length > 0 && plot != this.getPlots()[0]) {
                return;
            }

            if (annotationAny.textMarkerPlot != plot && annotationAny.textMarker != null)
                annotationAny.textMarker.remove();

            if (plot == null) return;

            if (yScale == null || coords == null || coords.valueAnchor == null) return;

            let textMarker: anychart.core.axisMarkers.Text = annotationAny.textMarker;

            if (textMarker == null) {
                if (this.tradingLines[index] != undefined) {
                    // if( (this.tradingLines[index].marketPriceLine == annotation ||
                    //    this.tradingLines[index].marketStopLine == annotation ||
                    //    this.tradingLines[index].marketLimitLine == annotation )
                    // && !this.tradingLines[index].showPriceValuess && !this.tradingLines[index].showTradeNumbers
                    // )
                    // {
                    // return;
                    // }
                    if (this.tradingLines[index].isMobile) {
                        return;
                    }
                }

                if (index > -1) {
                    if (this.tradingLines[index].showPriceValuess) {
                        textMarker = plot.textMarker(this.newTextMarkerIndex);
                        textMarker.axis(plot.yAxis());
                        textMarker.hAlign("center");
                        textMarker.align("right");

                        textMarker.fontColor("white");
                        textMarker.zIndex(999999);
                        textMarker.background("orange");

                        textMarker.anchor("left-center");
                        annotationAny.textMarker = textMarker;
                        annotationAny.textMarkerPlot = plot;
                    } else {
                        textMarker = plot.textMarker(this.newTextMarkerIndex);
                        textMarker.axis(plot.yAxis());
                        annotationAny.textMarker = textMarker;
                        annotationAny.textMarkerPlot = plot;
                    }
                } else {
                    textMarker = plot.textMarker(this.newTextMarkerIndex);

                    textMarker.axis(plot.yAxis());

                    textMarker.hAlign("center");
                    textMarker.align("right");

                    textMarker.fontColor("white");
                    textMarker.zIndex(999999);
                    textMarker.background("orange");

                    textMarker.anchor("left-center");

                    annotationAny.textMarker = textMarker;
                    annotationAny.textMarkerPlot = plot;
                }
            }

            const valueAnchor =
                yScale.inverseTransform(
                    (pixelBounds.getBottom() - annotationAny.coords.valueAnchor) / pixelBounds.getHeight()
                ) || annotationAny.valueAnchor();
            if (valueAnchor !== undefined) {
                if (this.tradingLines[index] != undefined) {
                    if (textMarker && this.tradingLines[index].showPriceValuess) {
                        textMarker.value(Number(valueAnchor));
                        textMarker.text(Number(valueAnchor).toFixed(this.Decimal));
                    }
                } else {
                    textMarker.value(Number(valueAnchor));
                    textMarker.text(Number(valueAnchor).toFixed(this.Decimal));
                }

                let offsetX = 10;
                let offsetY = -10;

                if (index > -1 && this.tradingLines[index].marketPriceLine == annotation) {
                    let cl = invertColor(this.tradingLines[index].marketColor, true);

                    textMarker.fontColor(cl);
                    textMarker.background(this.tradingLines[index].marketColor);

                    annotation.allowEdit(false);
                    this.tradingLines[index].marketPriceMarker = textMarker;

                    if (this.tradingLines[index].marketPriceMarkerInfo) {
                        // annotationAny.textMarker.remove();
                        this.tradingLines[index].marketPriceMarkerInfo!.enabled(false);
                        //  this.tradingLines[index].marketStopMarkerInfo.value(Number(valueAnchor));
                    }

                    if (this.tradingLines[index].showTradeNumbers) {
                        let textMarkerMPL: anychart.core.axisMarkers.Text = annotationAny.textMarker;
                        textMarkerMPL = plot.textMarker(this.newTextMarkerIndex);
                        textMarkerMPL.axis(plot.yAxis());
                        //   textMarkerMPL.hAlign("center");
                        textMarkerMPL.align("left");
                        textMarkerMPL.fontColor(this.tradingLines[index].marketColor);
                        textMarkerMPL.zIndex(999999);
                        textMarkerMPL.background("none");
                        textMarkerMPL.anchor("left-center");
                        textMarkerMPL.value(Number(valueAnchor));
                        textMarkerMPL.offsetX(offsetX);
                        textMarkerMPL.offsetY(offsetY);
                        textMarkerMPL.text(this.tradingLines[index].marketLineLabel);
                        console.log("this.itemID-draws");
                        console.log(this.itemID);
                        this.tradingLines[index].marketPriceMarkerInfo = textMarkerMPL;
                    }
                }

                if (
                    index > -1 &&
                    this.tradingLines[index].marketStopLine == annotation &&
                    this.tradingLines[index].showTradeNumbers
                ) {
                    if (textMarker && this.tradingLines[index].showPriceValuess) {
                        textMarker.background(this.tradingLines[index].stopColor);
                        this.tradingLines[index].marketStopMarker = textMarker;
                    }

                    if (this.tradingLines[index].marketStopMarkerInfo) {
                        // annotationAny.textMarker.remove();
                        this.tradingLines[index].marketStopMarkerInfo!.enabled(false);
                        //  this.tradingLines[index].marketStopMarkerInfo.value(Number(valueAnchor));
                    }
                    //  else
                    //    {

                    if (this.tradingLines[index].showTradeNumbers) {
                        let textMarkerS: anychart.core.axisMarkers.Text = annotationAny.textMarker;
                        textMarkerS = plot.textMarker(this.newTextMarkerIndex);
                        textMarkerS.axis(plot.yAxis());
                        //   textMarkerMPL.hAlign("center");
                        textMarkerS.align("left");
                        textMarkerS.fontColor(this.tradingLines[index].marketColor);
                        textMarkerS.fontSize(14);
                        textMarkerS.zIndex(999999);
                        textMarkerS.background("none");
                        textMarkerS.anchor("left-center");
                        textMarkerS.value(Number(valueAnchor));
                        textMarkerS.offsetX(offsetX);
                        textMarkerS.offsetY(offsetY);
                        textMarkerS.text(this.tradingLines[index].stopLineLabel);
                        this.tradingLines[index].marketStopMarkerInfo = textMarkerS;
                    }
                    //     }
                }

                if (index > -1 && this.tradingLines[index].marketLimitLine == annotation) {
                    if (textMarker && this.tradingLines[index].showPriceValuess) {
                        textMarker.background(this.tradingLines[index].limitColor);
                        this.tradingLines[index].marketLimitMarker = textMarker;
                    }

                    if (this.tradingLines[index].marketLimitMarkerInfo) {
                        this.tradingLines[index].marketLimitMarkerInfo!.enabled(false);
                    }
                    //      else
                    //       {

                    if (this.tradingLines[index].showTradeNumbers) {
                        let textMarkerL: anychart.core.axisMarkers.Text = annotationAny.textMarker;
                        textMarkerL = plot.textMarker(this.newTextMarkerIndex);
                        textMarkerL.axis(plot.yAxis());
                        //   textMarkerMPL.hAlign("center");
                        textMarkerL.align("left");
                        textMarkerL.fontColor(this.tradingLines[index].marketColor);
                        textMarkerL.fontSize(14);
                        textMarkerL.zIndex(999999);
                        textMarkerL.background("none");
                        textMarkerL.anchor("left-center");
                        textMarkerL.value(Number(valueAnchor));
                        textMarkerL.offsetX(offsetX);
                        textMarkerL.offsetY(offsetY);
                        textMarkerL.text(this.tradingLines[index].limitLineLabel);
                        this.tradingLines[index].marketLimitMarkerInfo = textMarkerL;
                    }

                    //         }
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    undecorateAnnotation(annotation: anychart.core.annotations.Base) {
        const annotationAny = <any>annotation;
        if (annotationAny.textMarker != null) annotationAny.textMarker.enabled(false); //after remove textMarker shows up again after few secs
    }

    getAnnotations(plot?: anychart.core.stock.Plot) {
        if (plot == undefined) plot = this.chart.plot();
        const annotations = [];
        const plotAnnotations = plot.annotations();
        const annotationsCount = plotAnnotations.getAnnotationsCount();
        for (let j = 0; j < annotationsCount; j++) {
            annotations.push(plotAnnotations.getAnnotationAt(j));

            //     console.log("plotAnnotations.getAnnotationAt(j).normal().stroke()");

            try {
                let colorData = (plotAnnotations
                    .getAnnotationAt(j)
                    .normal()
                    .stroke() as any).color;
                //          console.log("colorData");
                //           console.log(colorData);

                //  colorData = "#ff00ff";
                plotAnnotations
                    .getAnnotationAt(j)
                    .normal()
                    .labels()
                    .fontColor(colorData);
                plotAnnotations
                    .getAnnotationAt(j)
                    .hovered()
                    .labels()
                    .fontColor(colorData);
                plotAnnotations
                    .getAnnotationAt(j)
                    .selected()
                    .labels()
                    .fontColor(colorData);
            } catch (e) {
                console.log(e);
            }
        }
        return annotations;
    }

    saveAnnotations() {
        // for (let l = 0; l < this.tradingLines.length; l++) {
        //     this.tradingLines[l].removeTradeLines();
        // }

        //   this.drawTradeLinesAction();

        //return;
        const plotsCount = this.chart.getPlotsCount();
        const annotations: Object[] = [];
        for (let i = 0; i < plotsCount; i++) {
            const plotAnnotations = this.chart.plot(i).annotations();
            const annotationsCount = plotAnnotations.getAnnotationsCount();
            annotations[i] = plotAnnotations.toJson();
            for (let j = 0; j < annotationsCount; j++) {
                const annotation = plotAnnotations.getAnnotationAt(j);
                if (Utils.objectHasValue(annotation, "dontSave")) {
                    delete (<any>annotations)[i].annotationsList[j];
                    continue;
                }

               if(annotation.getType() == "horizontal-line")
               {
                   let astroke = annotation.normal().stroke();
                   if((astroke as any).dash == "5 2")
                   {
                        console.log("NOTSAVE");
                        delete (<any>annotations)[i].annotationsList[j];
                        continue;
                   }
                   //console.log(annotation.normal().stroke());
               }



                const flags = Utils.objectGetValues(annotation);
                Utils.objectSetValues((<any>annotations)[i].annotationsList[j], flags);
            }
        }

        this.workspace.charts[this.itemID].annotations[this.Config.DisplayMode] = annotations;
        
        if(this.workspace.charts[this.itemID].annotationsPerSymbol[this.Config.DisplayMode]==undefined)
        {
            this.workspace.charts[this.itemID].annotationsPerSymbol[this.Config.DisplayMode] = [];
        }

        let symbolRow = this.workspace.charts[this.itemID].annotationsPerSymbol[this.Config.DisplayMode].find(v=>{
            return v.symbol == this.symbol
        })

        if(symbolRow)
        {
            symbolRow.annotations = annotations;
        }
        else
        {
            this.workspace.charts[this.itemID].annotationsPerSymbol[this.Config.DisplayMode].push({symbol:this.symbol, annotations:annotations});
        }

       

        console.log(this.workspace.charts[this.itemID].annotationsPerSymbol);

        this.workspace.charts[this.itemID].setHasChanges(true);
        this.workspace.save();

     //  this.drawTradeLinesAction();

        // //   if(this.showtradeLines)
        // //    {
        // if(this.tradingLines[0].tempTradeData != null && this.tradingLines[0].tempTradeData.Symbol == this.symbol) {

        //     for(let l=0;l<this.selectedChart.tradingLines.length;l++)
        //     {
        //       this.tradingLines[l].backgroundColor(this.BackgroundColor);
        //       this.tradingLines[l].drawTradeLines(this.tradingLines[l].tempTradeData);

        // //     }

        //         if(this.tradingLines[l].marketPriceLine) this.decorateAnnotation(<any> this.tradingLines[l].marketPriceLine);

        //         if(this.tradingLines[l].marketStopLine) this.decorateAnnotation(<any> this.tradingLines[l].marketStopLine);

        //         if(this.tradingLines[l].marketLimitLine) this.decorateAnnotation(<any> this.tradingLines[l].marketLimitLine);
        //     }
        // }
        //   const ann2 = this.getAnnotations(this.chart.plot());//.annotations();
        //   ann2.forEach(a => this.decorateAnnotation(a));
    }

    loadAnnotations() {
        if (this.chart) {

            let selectedAnnotations = null;
            if(this.Config.annotationsPerSymbol && this.Config.annotationsPerSymbol[this.Config.DisplayMode])
            {
                selectedAnnotations = this.Config.annotationsPerSymbol[this.Config.DisplayMode].find(v=>{
                    return v.symbol == this.symbol
                })
            }   
            


            if (selectedAnnotations!=null || this.Config.annotations) {

                
                const annotations = (selectedAnnotations)?selectedAnnotations.annotations:this.Config.annotations[this.Config.DisplayMode]; 

                const plotsCount = this.chart.getPlotsCount();
                for (let i = 0; i < plotsCount; i++) {
                    const plot = this.plot(i);
                    const ann1 = this.getAnnotations(plot);
                    ann1.forEach(a => this.undecorateAnnotation(a));
                    plot.annotations().removeAllAnnotations();
                    if (annotations != null && annotations[i] != null) {


                        (annotations[i] as any).annotationsList.forEach( (v: any) =>{
                            if(v!=null)
                            {
                                if(v.type=="horizontal-line" && v.normal.stroke.dash=="5 2")
                                {
                                    let index =  (annotations[i] as any).annotationsList.indexOf(v)
                                    console.log(index);
                                    delete (annotations[i] as any).annotationsList[index];
                                }
                            }
                           
                        })
                     

                        plot.annotations().fromJson(annotations[i]);

                        const ann = this.getAnnotations(plot);
                        ann.forEach((a, index) => {
                            // console.log("ann");
                            // console.log((ann as any).normal().stroke());
                            //   plotAnnotations.getAnnotationAt(j).normal().stroke()

                            let canLoad:boolean = true;
                            if(a.getType() == "horizontal-line")
                            {
                                // let astroke = a.normal().stroke();
                                // if((astroke as any).dash == "5 2")
                                // {
                                //    //  console.log(annotation.normal().stroke());
                                //      console.log("NOTSAVE");
                                //      delete (<any>annotations)[i].annotationsList[j];
                                //      continue;
                                // }
                                let astroke = a.normal().stroke();
                                if((astroke as any).dash == "5 2")
                                {
                                     console.log("NOLOADHORIZONTAL");
                                     canLoad=false;
                                //     plot.annotations().removeAnnotation(a)
                                }
                            }




                            if((<any>annotations)[i].annotationsList[index]!=null && canLoad)
                            {
                                        Utils.objectSetValues(
                                            a,
                                            Utils.objectGetValues((<any>annotations)[i].annotationsList[index])
                                        ); 
                                        if (i == 0) this.decorateAnnotation(a);
                            }
                          
                           
                        });
                    }
                }
            }

          //  this.canShowTrades = true;
        //   this.debug("AFTERLOADANNOTATION");
        //   this.canShowTrades = true;
        //   this.tradeLinesVisibilityService.drawActiveState();
            // if (this.tradingLines[0] != undefined) {
            //     if (this.tradingLines[0].tempTradeData != null) {
            //         // this.loadOrderData(this.tradingLines[0].tempTradeData);

            //         this.drawTradeLinesAction();
            //     }
            // }
        } else {
            setTimeout(() => {
                this.loadAnnotations();
                
                // this.debug("AFTERSETDATA");
                // this.canShowTrades = true;
                // this.tradeLinesVisibilityService.drawActiveState();
            }, 50);
        }
    }

    private _canShowTrades: boolean = false;
    public get canShowTrades(): boolean {
        return this._canShowTrades;
    }
    public set canShowTrades(value: boolean) {
        this._canShowTrades = value;

        // if (value == true) {
        //     this.activeTrades;
        // }
    }
    onDrop(): void {
        this._currentMaxHigh = -1;
        this.symbol = this._currentDraggedSymbol;
        this._lastQuoteData = [];
        this._lastQuoteData.push(Date.now());
        this._lastQuoteData.push(-1);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(1);

        this._canUpdateDataTable = false;

        this.candleStickSerie.name(this._currentDraggedSymbol);
        this.lineSerie.name(this._currentDraggedSymbol);
        this.ohclSerie.name(this._currentDraggedSymbol);
        if (this.TooltipSerie) this.TooltipSerie.name(this._currentDraggedSymbol);

        this.onSelectNewSymbol(this._currentDraggedSymbol);
    }

    async onSelectNewSymbol(e: string, overrideLockAllCharts?: boolean, mark?: boolean) {
        // for (let l = 0; l < this.tradingLines.length; l++) {
        //     this.tradingLines[l].tempTradeData = null;
        //     this.tradingLines[l].removeTradeLines();
        // }


        this.canShowTrades = false;
        this.tradeLinesVisibilityService.drawActiveState();

        if (this.wizard != null) {
            this.wizard._monitor.Symbol = e;
            this.wizard._monitor.requestForData(this.wizard);
        }

        if (this.symbol != e) {
            this.symbol = e;
        }

        this._currentMaxHigh = -1;
        this._lastQuoteData = [];
        this._lastQuoteData.push(Date.now());
        this._lastQuoteData.push(-1);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(0);
        this._lastQuoteData.push(1);

        this._canUpdateDataTable = false;

        this.refreshPeriod(undefined, true);

        if (this.candleStickSerie) this.candleStickSerie.name(e);
        if (this.lineSerie) this.lineSerie.name(e);
        if (this.ohclSerie) this.ohclSerie.name(e);
        if (this.TooltipSerie) this.TooltipSerie.name(e);
        this.updateChart(e, overrideLockAllCharts, mark);
       
    }

    updateChart(e: string, overrideLockAllCharts?: boolean, mark?: boolean) {
        if (this.chart) {
            this.chart
                .plot()
                .yAxis()
                .labels()
                .format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");

            let xLabel = this.chart
                .plot()
                .xAxis()
                .labels()
                .format("{%value}{dateTimeFormat:yyyy}");

            (<any>xLabel).format((s: any) => {
                var d = moment(s.tickValue);
                d.utc(false);
                switch (this.period) {
                    case HistoryItemPeriod.Min1:
                    case HistoryItemPeriod.Min3:
                    case HistoryItemPeriod.Min5:
                    case HistoryItemPeriod.Min10:
                    case HistoryItemPeriod.Min15:
                    case HistoryItemPeriod.Min30:
                    case HistoryItemPeriod.Min90:
                    case HistoryItemPeriod.Hr1:
                    case HistoryItemPeriod.Min120:
                    case HistoryItemPeriod.Hr3:
                    case HistoryItemPeriod.Hr4:
                    case HistoryItemPeriod.Hr6:
                        return d.format("DD MMM YYYY, HH:mm ");
                    default:
                        return d.format(" DD MMM YYYY ");
                }
            });

            let tooltip = this.chart.tooltip();

            tooltip.background().fill("#212a33");
            tooltip.fontColor("#838383");
            tooltip.title().fontColor("#838383");

            let currentDecimals = this.Decimal;

            (<any>tooltip).format((s: any) => {
                let formatString = "";

                if (s.open !== undefined) {
                    formatString += "" + s.seriesName + "\n";

                    formatString += "Open: " + Number(s.open).toFixed(currentDecimals) + "\n";
                    formatString += "High: " + Number(s.high).toFixed(currentDecimals) + "\n";
                    formatString += "Low: " + Number(s.low).toFixed(currentDecimals) + "\n";
                    formatString += "Close: " + Number(s.close).toFixed(currentDecimals) + "";
                }

                if (s.value !== undefined) {
                    formatString += "" + s.seriesName + ": " + Number(s.value).toFixed(currentDecimals) + "";
                }

                return formatString;
            });

            this.globaGridMode.emitSymbolChanged({ symbol: e, overrideLockAllCharts: overrideLockAllCharts });
            this.indicatorDecors.forEach((Decor: any) => {
                if (Decor.label() !== null) {
                    Decor.label().format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");
                }
            });
            this.workspace.save();
        } else {
            setTimeout(() => {
                this.updateChart(e, overrideLockAllCharts, mark);
            }, 50);
        }
    }

    onMouseEnter(): void {
        this.chartInstanceService.select.next(this);
    }

    private _contextMenu!: anychart.ui.ContextMenu;
    private get contextMenu(): anychart.ui.ContextMenu {
        this._contextMenu = this._contextMenu || this.chart.contextMenu();
        return this._contextMenu;
    }

    public get indicatorInstances(): IIndicatorInstances {
        return this.Config.DisplayMode == ChartDisplayMode.CHARTING
            ? this.Config.chartIndicatorInstances
            : this.Config.DisplayMode == ChartDisplayMode.WIZARD
            ? this.Config.wizardIndicatorInstances
            : {};
    }

    private _subMenuAction: string = "";
    DeleteIndicatorInstance(indicator: IIndicatorInstance, index: number, indicatorInstances: IIndicatorInstance[]) {
        if (indicator && indicator.indicator && indicator.indicator.defaults && indicator.indicator.defaults.item) {
            let pi = indicator.indicator.defaults.item.filter(i => i.name == "plotIndex").map(p => Number(p.value));
            let plotIndex = pi.length > 0 ? pi[0] : 0;
            plotIndex = plotIndex != NaN ? plotIndex : 0;

            if (indicator.insance) {
                (<any>indicator.insance).dispose();
                delete indicator.insance;
            }

            indicatorInstances = indicatorInstances.filter((i, indx) => {
                return indx != index;
            });

            if (plotIndex > 0) {
                plotIndex =
                    // all indicators on one plot 0- chart 1-tabs 2-indicators
                    plotIndex = plotIndex > 0 ? 2 : 0;

                let plot = this.plot(plotIndex);
                if (plot.getSeriesCount() == 0) {
                    try {
                        (<any>plot).dispose();
                    } catch {}
                }
            }
        }
        return indicatorInstances;
    }

    removeAllIndicatorInstances() {
        Object.keys(this.indicatorInstances).forEach(key => {
            while ((this.indicatorInstances[key] || []).length > 0) {
                this.indicatorInstances[key] = this.DeleteIndicatorInstance(
                    this.indicatorInstances[key][0],
                    0,
                    this.indicatorInstances[key]
                );
            }
        });
        this.saveUserIndicators();
        this.workspace.save();
    }

    removeAllAnnotations() {
        this.getAnnotations(this.plot()).forEach(a => this.undecorateAnnotation(a));
        this.plot()
            .annotations()
            .removeAllAnnotations();
        this.saveAnnotations();
    }

    updateIndicatorsPlotHeight(height: string) {
        Object.keys(this.indicatorInstances).forEach(x => {
            this.indicatorInstances[x].forEach(d => {
                d.selectedHeight = height;
            });
        });
    }

    getMaxIndicatorHeight(indicatos: IIndicatorInstances): string {
        var res = 25;
        Object.keys(indicatos).forEach(x => {
            indicatos[x].forEach(d => {
                res = isNaN(Number(d.selectedHeight))
                    ? res
                    : res < Number(d.selectedHeight)
                    ? Number(d.selectedHeight)
                    : res;
            });
        });
        return res.toString();
    }

    loadTemplate(template: ITemplate): void {
        if (template.background) {
            this.BackgroundColor = template.background;
        }
        if (template.axis) {
            this.AxisColor = template.axis;
        }
        if (template.grid) {
            this.GridColor = template.grid;
        }
        if (template.minorGrid) {
            this.MinorGridColor = template.minorGrid;
        }
        if (template.chartingPriceline) {
            this.LineSeriesColor = template.chartingPriceline;
        }
        if (template.candleBorder) {
            this.CandleStickSerieBorderColor = template.candleBorder;
        }
        if (template.bearishCandle) {
            this.CandleStickSerieFallingColor = template.bearishCandle;
        }
        if (template.bullishCandle) {
            this.CandleStickSerieRisingColor = template.bullishCandle;
        }
        if (template.font) {
            this.FontColor = template.font;
        }
        if (template.crosshair) {
            this.CrosshairColor = template.crosshair;
        }
    }

    ShowIndicatorInstance(
        indicator: IIndicatorInstance,
        index: number,
        instances: IIndicatorInstance[]
    ): IIndicatorInstance[] {
        instances = instances || [];
        this.ShowInstance(indicator);
        if (index < 0) {
            instances.push(indicator);
        } else {
            instances[index] = indicator;
        }
        instances.forEach(x => {
            if (indicator.selectedHeight) {
                x.selectedHeight = indicator.selectedHeight;
            }
        });
        if (this.workspace.chartDisplayMode == ChartDisplayMode.CHARTING) {
            this.setBackgroundColor(this.Config.BackgroundColor);
            this.CrosshairColor = this.Config.CrosshairColor;
            this.setChartFontColor(this.Config.FontColor);
            this.setChartAxisColor(this.Config.AxisColor);
        }

        this.refreshIndicatorMenuItem(indicator.indicator, instances);

        // this.workspace.HasChanges = true;
        return instances;
    }

    refreshIndicatorMenuItem(indicator: IIndicator, instances?: IIndicatorInstance[]) {
        if (!instances) instances = this.indicatorInstances[indicator.type];
        const menuItem = this.indicatorMenuItem.get(indicator.title);

        if (menuItem) {
            menuItem.submenu = this.getIndicatorMenuItemSubmenu(instances, indicator);
            menuItem.buttons = this.getIndicatorMenuItemButtons(instances.length);
        }
    }

    ShowInstance(indicator: IIndicatorInstance): IIndicatorInstance {
        if (indicator.mapping) {
            (<any>indicator.mapping).dispose();
            delete indicator.mapping;
            indicator.mapping = undefined;
        }

        let settings: any[] = [null];

        let plotIndex = 0;

        indicator.indicator.defaults.item.forEach(item => {
            let key = item.name;
            if (key != "plotIndex" && key != "overview") {
                settings.push(item.value);
            }
            if (key == "plotIndex") {
                plotIndex = Number(item.value);
            }
        });

        if (plotIndex > 0) {
            settings[0] = this.ohlcMapping;
        } else {
            let v = indicator.indicator.defaults.basedOn || "close";

            indicator.mapping = this.dataTable.mapAs({
                x: 0,
                open: 1,
                high: 2,
                low: 3,
                close: 4,
                value: v == "close" ? 4 : v == "open" ? 1 : v == "high" ? 2 : v == "low" ? 3 : 4
            });
            settings[0] = indicator.mapping;
        }

        // all indicators on one plot 0- chart 1-tabs 2-indicators
        plotIndex = plotIndex > 0 ? 2 : 0;

        let plot = this.plot(plotIndex);

        if (this.Config.DisplayMode != ChartDisplayMode.WIZARD) {
            plot.xGrid(plotIndex).palette([this.Config.BackgroundColor]);
        }

        if (indicator.insance) {
            (<any>indicator.insance).dispose();
            delete indicator.insance;
        }
        if (indicator.enabled === true) {
            let indicatorMethod = indicator.indicator.type;
            ~indicatorMethod.toLowerCase().indexOf("stochastic") && (indicatorMethod = "stochastic");
            let tmp: anychart.core.stock.indicators.Base = <anychart.core.stock.indicators.Base>(
                (<any>plot)[indicatorMethod].apply(plot, settings)
            );
            let title = `${getInputLabelText(indicator.indicator.type)} (${indicator.indicator.defaults.item
                .filter(x => !x.name.endsWith("Type") && x.name != "plotIndex")
                .map(p => {
                    return `${getInputLabelText(p.name)}:${p.value}`;
                })
                .join(",")})`;

            indicator.insance = tmp;

            indicator.title = title;
            if (plotIndex > 0) {
                plot.yAxis(1).orientation("right");

                let yLabel = plot.crosshair().yLabel();
                yLabel.axisIndex(1);
                yLabel.format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");
                plot;
                //  plot.minHeight("25%");
                //   plot.maxHeight("75%");
                //   let height = 100 - Number(indicator.selectedHeight);
                //     this.chart.plot(0).height(`${ height || "75" }%`);

                //    if(plotIndex == 2)

                try{
                    plot.height(`${indicator.selectedHeight || "25"}%`);
                }
                catch(e)
                {
                    console.log(e);
                }



            }
            indicator.indicator.defaults.item.forEach(v => {
                try
                {
                
                
                if (v.type == "string") {
                    let key = v.name;

                    if ((key.endsWith("Type") || key.endsWith("Series")) && tmp) {
                        let color = v.color || "#000000";
                        let width = v.width;

                        let seriesName = v.value;

                        let optType = "";

                        //    let obj = (<any>tmp)[key.replace("Type", "")]();
                        //     Object.keys(obj).forEach(k=>{
                        //         if(k.toLowerCase().indexOf('stroke')){
                        //             obj[k](`${width} ${color}`);
                        //         }
                        //     });

                        switch (seriesName) {
                            case "range-area":
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                                (<any>tmp)[key.replace("Type", "")]()["fill"](color);
                            case "Column":
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                                (<any>tmp)[key.replace("Type", "")]()["fill"](color);
                            case "Marker":
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                                (<any>tmp)[key.replace("Type", "")]()["fill"](color);
                            case "Area":
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                                (<any>tmp)[key.replace("Type", "")]()["fill"](color);
                            case "Step-area":
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                                (<any>tmp)[key.replace("Type", "")]()["fill"](color);
                                break;
                            default:
                                (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                        }

                        var serie = (<any>tmp)[key.replace("Type", "")]();
                        if (serie.connectMissingPoints) {
                            serie.connectMissingPoints(true);
                        }

                        if (key == "rangeSeriesType") {
                            (<any>tmp).rangeSeries("range-area");

                            //  (<any>tmp).rangeSeries().highStroke("22 #ff000", 2, 2);;
                            //  (<any>tmp).rangeSeries().lowStroke(`${width} ${color}`, 2, 2);
                            (<any>tmp).rangeSeries().fill(color);
                            // (<any>tmp)[key]() = "step-line";
                            if ((<any>tmp).rangeSeries().connectMissingPoints) {
                                (<any>tmp).rangeSeries().connectMissingPoints(true);
                            }
                        } else if (
                            indicator.indicator.defaults.item.filter(i => i.name == "rangeSeriesType").length > 0
                        ) {
                            (<any>tmp).rangeSeries().highStroke(`${width} ${color}`);
                            (<any>tmp).rangeSeries().lowStroke(`${width} ${color}`);
                            if ((<any>tmp).rangeSeries().connectMissingPoints) {
                                (<any>tmp).rangeSeries().connectMissingPoints(true);
                            }
                        }
                    }
                }
                    //   (<any>tmp).enabled(false);

                    // if (key.endsWith("Type") && tmp) {
                    //     let color = v.color;
                    //     let width = v.width;
                    //     (<any>tmp)[key.replace("Type", "")]()["stroke"](`${width} ${color}`);
                    // }
                }
                catch(e)
                {
                    console.log(e);
                }
            });

            plot.enabled(true);
        }

        this.drawTitle();
        this.drawIndicatorTab();

        this.indicatorLastValueDecorator(indicator, plotIndex);

        return indicator;
    }

    public addScannerChartingItem(searchrule: any) {
        this.workspace.currentScannerIndicator = [];

        setTimeout(() => {
            let rule;
            let study;
            if (this.workspace.isNarrowScanMode) {
                study = this.workspace.scannerSearch_Narrow_chartingstudy;
                rule = this.workspace.scannerCurrentRule_Narrow;
            } else {
                study = this.workspace.scannerSearch_chartingstudy;
                rule = this.workspace.scannerCurrentRule;
            }

            switch (study) {
                case ScannerChartingStudy.SCANNER_RSI:
                    var plot_1 = this.chart.plot(2);
                    // create RSI indicator with period 14
                    let base = plot_1.rsi(this.lineMapping, rule.period).series();
                    this.workspace.currentScannerIndicator = [base.getIndex(), 2, base, "rsi"];
                    //  this.workspace.currentScannerIndicator.
                    // this.workspace.currentScannerIndicator.enabled(true);
                    break;

                case ScannerChartingStudy.SCANNER_BOLLINGERBANDS:
                    var plot_1 = this.chart.plot(0);
                    // create RSI indicator with period 14
                    var bb = plot_1.bbands(this.lineMapping, rule.period, rule.deviation);

                    this.workspace.currentScannerIndicator = [
                        [
                            bb.upperSeries().getIndex(),
                            bb.lowerSeries().getIndex(),
                            bb.middleSeries().getIndex(),
                            bb.rangeSeries().getIndex()
                        ],
                        0,
                        bb,
                        "bb"
                    ];
                    break;

                case ScannerChartingStudy.SCANNER_EMA:
                    var plot_1 = this.chart.plot(0);
                    // create RSI indicator with period 14
                    let base_ema = plot_1.ema(this.lineMapping, rule.period).series();
                    this.workspace.currentScannerIndicator = [base_ema.getIndex(), 0, base_ema, "ema"];
                    break;

                case ScannerChartingStudy.SCANNER_MACD:
                    var plot_1 = this.chart.plot(2);
                    // create RSI indicator with period 14
                    var macd = plot_1.macd(this.lineMapping, rule.fast_period, rule.slow_period, rule.signal_period);
                    this.workspace.currentScannerIndicator = [
                        [
                            macd.macdSeries().getIndex(),
                            macd.signalSeries().getIndex(),
                            macd.histogramSeries().getIndex()
                        ],
                        2,
                        macd
                    ];
                    break;
            }
        }, 500);

        //  rsi , b

        //   this.indicatorInstances["rsi"] = this.ShowIndicatorInstance(
        //     definition,
        //     -1,
        //     this.indicatorInstances
        // );
    }

    public saveUserIndicators() {
        if (this._indicatorLoaded == true) {
            var wizInd = DeepCopyIndicators([this.Config.wizardIndicatorInstances]);
            var chartInd = DeepCopyIndicators([this.Config.chartIndicatorInstances]);
            this.workspace.setToUserStore(`wizIndicators_${this.itemID}`, JSON.stringify(wizInd));
            this.workspace.setToUserStore(`chartIndicators_${this.itemID}`, JSON.stringify(chartInd));
        }
    }

    public loadAndShowIndicators() {
        if (this._indicatorLoaded == false) {
            this.loadUserIndicators();
            this.showIndicators(this.indicatorInstances);

            this._indicatorLoaded = true;
        }
    }

    public loadUserIndicators() {
        //  debugger;
        var wizIndStr = this.workspace.getFromUserStore(`wizIndicators_${this.itemID}`);
        if (wizIndStr && wizIndStr != "") {
            this.Config.wizardIndicatorInstances = JSON.parse(wizIndStr);
        }
        var chartIndStr = this.workspace.getFromUserStore(`chartIndicators_${this.itemID}`);
        if (chartIndStr && chartIndStr != "") {
            this.Config.chartIndicatorInstances = JSON.parse(chartIndStr);
        }
        this._indicatorLoaded = true;
        this.drawTitle();
    }

    public hideIndicators(indicatos: IIndicatorInstances) {
        let tmp: IIndicatorInstances = {};

        Object.keys(indicatos).forEach(key => {
            tmp[key] = [];
            indicatos[key].forEach(ind => {
                if(ind.insance){
                    tmp[key].push(ind);
                }
            });
        });

        Object.keys(tmp).forEach(key => {
            while ((tmp[key] || []).length > 0) {
                let ind = <IIndicatorInstance>tmp[key][0];
                tmp[key] = this.DeleteIndicatorInstance(ind, 0, tmp[key]);
            }
        });

        Object.keys(indicatos).forEach(key => {
            (indicatos[key] || []).forEach(ind => {
                if(ind.insance){
                delete ind.insance;
                }
                ind.insance=undefined;
            });
        });

        // let plots = [];//this.chart.getPlotsCount()

        // for(var i = 1; i<this.chart.getPlotsCount();i++)
        // {
        //     plots.push(
        //                 this.chart.plot(i)
        //     );
        // }

        // plots.forEach(v=>{
        //   //  v
        //     (<any>v).dispose();
        // })

        // while (this.chart.getPlotsCount() > 1) {

        //     (<any>this.chart.plot(1)).dispose();
        // }

        //this.workspace.HasChanges = true;
    }

    public async hideAnnotations() {
        let allowedPlots = [0, 1];

        allowedPlots.forEach(plotNum => {
            let plot = this.plot(plotNum);
            const ann = this.getAnnotations(plot);
            ann.forEach(a => a.enabled(false));
        });
    }

    public showIndicators(indicatos: IIndicatorInstances): Promise<void> {
        return new Promise<void>((rs, rj) => {
            for (var k in indicatos) {
                if (indicatos[k] && indicatos[k].length == 0) {
                    delete indicatos[k];
                }
            }
            if (Object.keys(indicatos).length > 0) {
                var height = this.getMaxIndicatorHeight(indicatos);
                Object.keys(indicatos).forEach(key => {
                    try
                    {
                    indicatos[key].forEach((ind, index) => {
                        ind.selectedHeight = height;
                        this.ShowIndicatorInstance(ind, index, indicatos[key]);
                    });
                    }
                    catch(e)
                    {
                        console.log(e);
                    }
                });

                this.saveUserIndicators();
                this.workspace.save();
                //this.showSupportLines().then(() => {
                this.computeAndSetSupportLines()
                    .then(() => {
                        this.drawTitle()
                            .then(() => {
                                this.drawIndicatorTab();
                                rs();
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    })
                    .catch(e => {
                        console.error(e);
                    });
                //});
            } else {
                //this.showSupportLines().then(() => {
                this.computeAndSetSupportLines()
                    .then(() => {
                        this.drawTitle()
                            .then(() => {
                                this.drawIndicatorTab();
                                rs();
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    })
                    .catch(e => {
                        console.error(e);
                    });
                //});
            }
        });
    }

    public set showResistanceLines(v: boolean) {
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            this.Config.chartingshowResistanceLines = v;
        } else if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
            this.Config.wizardshowResistanceLines = v;
        }
    }

    public get showResistanceLines() {
        if (this.Config.DisplayMode == ChartDisplayMode.CHARTING) {
            return this.Config.chartingshowResistanceLines;
        } else if (this.Config.DisplayMode == ChartDisplayMode.WIZARD) {
            return this.Config.wizardshowResistanceLines;
        } else {
            return false;
        }
    }

    public showSRLines() {
        this.showResistanceLines = !this.showResistanceLines;
        this.showSupportLines();
        if (this.workspace.mobileMode != "desktop") {
        }
    }

    private _showGrid = false;

    set showGrid(v: boolean) {
        this._showGrid = v;
        this.zone.runOutsideAngular(() => {
            var bg = "#ffffff 0.2";
            var state = true;
            if (v == false) {
                var bg = "#212a33 0.0";
                state = false;
            }

            // this.plot()
            //     .xGrid()
            //     .enabled(state);
            switch (this.Config.DisplayMode) {
                case ChartDisplayMode.CHARTING:
                    this.xGrid().stroke(this.GridColor);
                    this.xGrid().enabled(state);
                    this.plot()
                        .xMinorGrid()
                        .stroke(this.GridColor);
                    this.plot()
                        .xMinorGrid()
                        .enabled(state);
                    break;
                case ChartDisplayMode.ENTSIGNALS:
                    this.xGrid().enabled(true);
                    this.plot()
                        .xMinorGrid()
                        .enabled(false);
                    break;
                case ChartDisplayMode.WIZARD:
                    // this.plot()
                    //     .xMinorGrid()
                    //     .enabled(false);
                    //   this.xGrid().stroke(this.GridColor);
                    //     this.xGrid().enabled(state);
                    // this.plot()
                    //     .xMinorGrid()
                    //     .stroke(this.GridColor);
                    //     this.plot()
                    //     .xMinorGrid()
                    //     .stroke(this.GridColor);
                    // // this.plot()
                    // //     .xMinorGrid()
                    // //     .enabled(state);


                    // this.xGrid().enabled(true);
                    // this.plot()
                    //     .xMinorGrid()
                    //     .enabled(state);

                        var bgG = "#26c524 0.0";
                        this.xGrid().palette([ChartColorTable.ColorWizardGreen]);
                        if(state)
                        {
                            this.xGrid().stroke(this.GridColor);
                         //   this.xGrid().zIndex(10000000000000);
                        }
                        else
                        {
                            this.xGrid().stroke(bgG);
                       //     this.xGrid().zIndex(0);
                        }
                        

                    break;
            }
        });
    }

    public showResistance() {}

    chartDbClick() {
        if (this.workspace.layoutMode != "1" + this.layoutID.toString()) {
            this.workspace.prevDisplayModeForChartDisplayMode[
                this.workspace.chartDisplayMode
            ] = this.workspace.displayModeForChartDisplayMode[this.workspace.chartDisplayMode];
            this.workspace.layoutMode = "1" + this.layoutID.toString();
        } else {
            this.workspace.layoutMode = this.workspace.prevDisplayModeForChartDisplayMode[
                this.workspace.chartDisplayMode
            ];
        }
    }

    public onHideTradeDeskAction = false;

    private _tradingLines: tradingLines[] = [];
    public get tradingLines(): tradingLines[] {
        return this._tradingLines;
    }
    public set tradingLines(value: tradingLines[]) {

        let find = value.find(v=>{
            return v.tempTradeData == null;
        })

      

        this._tradingLines = value;
    }

   


  

    private _showMultipleTradeLines: boolean = true;
    public get showMultipleTradeLines(): boolean {
        return this._showMultipleTradeLines;
    }
    public set showMultipleTradeLines(value: boolean) {
        this._showMultipleTradeLines = value;
    }

    

    private _indicatorLineThickness: number = 0;
    public get indicatorLineThickness(): number {
        return this._indicatorLineThickness;
    }
    public set indicatorLineThickness(value: number) {
        this._indicatorLineThickness = value;
    }

    indicatorDecors: any = [];
    public initIndexForLabelIndicator = 10;
    indicatorLastValueDecorator(indicator: IIndicatorInstance, plotIndex: number) {
        indicator.indicator.defaults.item.forEach(v => {
            let key = v.name;

            if ((key.endsWith("Type") || key.endsWith("Series")) && indicator.insance) {
                let color = v.color || "#000000";

                let seriesName = key.replace("Type", "");
                if (seriesName.endsWith("Series") || seriesName.endsWith("series")) {
                    let serie = (<any>indicator.insance)[key.replace("Type", "")]();
                    //        serie.stroke(`27 ${color}`);

                    this.initIndexForLabelIndicator++;

                    let plot = this.plot(plotIndex);

                    let Decor = plot.priceIndicator(this.initIndexForLabelIndicator);
                    Decor.series(serie);
                    Decor.valueField("value");
                    Decor.value("series-end");

                    Decor.label()
                        .background()
                        .fill(`${color}`);
                    Decor.label().fontColor(rgbaStrToHex(color, true));

                    if (this.workspace.showIndicatorLines) {
                        this.indicatorLineThickness = 1;
                    }

                    Decor.stroke("Black", this.indicatorLineThickness);

                    this.indicatorDecors.push(Decor);

                    Decor.label().format("{%value}{decimalsCount:" + this.Decimal + ", zeroFillDecimals:true}");

                    let axis = plotIndex == 0 ? 0 : 1;
                    Decor.axis(axis);
                }
            }
        });

        //  indicator.insance!.

        //   indicator.indicator.
    }
}

export function rgbaStrToHex(str:string, bw: any)
{
    let result = str.substring(5, str.length-1);
    let resultEx = result.split(",");
    var r: any = resultEx[0],
    g: any = resultEx[1],
    b: any = resultEx[2];
    if (bw) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }

    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);

    return "#" + padZero(r) + padZero(g) + padZero(b);
}



export  function getContrastYIQ(hexcolor:any,bt:boolean){
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? '#000000' : '#ffffff';
}


export function invertColor(hex: any, bw: any) {
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }

    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    // if (hex.length !== 6) {
    //     throw new Error('Invalid HEX color.');
    // }
    var r: any = parseInt(hex.slice(0, 2), 16),
        g: any = parseInt(hex.slice(2, 4), 16),
        b: any = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }

    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);

    return "#" + padZero(r) + padZero(g) + padZero(b);
}

export function padZero(str: any, len: any = "") {
    len = len || 2;
    var zeros = new Array(len).join("0");
    return (zeros + str).slice(-len);
}

export interface IXLabelFormat {
    value: string;
    tickValue: number;
}

export interface IYLabelFormat {
    max: number;
    min: number;
    rawValue: number;
    tickValue: number;
    value: number;
}

export function formatcrosshairLabel(cmp: AChartComponent) {
    let crosshair = cmp.chart.crosshair();
    crosshair.displayMode("float");

    let XlabelCrossHair = cmp.chart.plot(0).crosshair();

    XlabelCrossHair.enabled(true);
    XlabelCrossHair.xLabel().enabled(true);

    var xLabel = XlabelCrossHair.xLabel();
    var yLabel = crosshair.yLabel();
    (<any>xLabel).format((s: any) => {
        if (s.tickValue) {
            var d = moment(s.tickValue);
            d.utc(false);

            let goal = s.tickValue;
            var closest = cmp.mapMatcher.reduce(function(prev, curr) {
                return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
            });

            var e = moment(closest);
            e.utc(false);

            switch (cmp.period) {
                case HistoryItemPeriod.Min1:
                case HistoryItemPeriod.Min3:
                case HistoryItemPeriod.m2:
                case HistoryItemPeriod.m4:
                case HistoryItemPeriod.Min2:
                case HistoryItemPeriod.Min5:
                case HistoryItemPeriod.Min10:
                case HistoryItemPeriod.Min15:
                case HistoryItemPeriod.Min30:
                case HistoryItemPeriod.Min90:
                case HistoryItemPeriod.Hr1:
                case HistoryItemPeriod.Hr2:
                case HistoryItemPeriod.Min120:
                case HistoryItemPeriod.Hr3:
                case HistoryItemPeriod.Hr4:
                case HistoryItemPeriod.Hr6:
                case HistoryItemPeriod.H8:
                case HistoryItemPeriod.H12:
                    //return d.format("DD MMM YYYY, HH:mm ");
                    return e.format("HH:mm ");
                // return hour + ":" + minute;//d.format("HH:mm ");
                case HistoryItemPeriod.S5:
                case HistoryItemPeriod.S10:
                case HistoryItemPeriod.S15:
                case HistoryItemPeriod.S30:
                    return e.format("HH:mm:ss ");
                default:
                    return d.format(" DD MMM YYYY ");
            }
        }
        return "";
    });

    (<any>yLabel).format((s: IYLabelFormat) => s.rawValue.toFixed(cmp.Decimal).toString()); //.format("{%value}{decimalsCount:" + cmp.Decimal + ", zeroFillDecimals:true}");
}

function roundToFive(num: any, period: any) {
    var temp = num % 5;
    if (temp < 3) return num - temp;
    else return num + 5 - temp;
}

function drawEmaWithoutFuture(
    plot: anychart.core.stock.Plot,
    dataTableWiz: anychart.data.Table,
    lineMappingEma: anychart.data.TableMapping,
    period: number,
    maxDate: number
) {
    //  dataTableWiz.remove(0,100)
   
    const mapping = dataTableWiz.mapAs({ value: 3, date: 0 });

    const computer = anychart.math.ema.createComputer(lineMappingEma, period);

    mapping.addField("value", computer.getFieldIndex("result"));
    mapping.addField("dt", 0);

    let sel = mapping.createSelectable().selectAll();
    var iterBlack = sel.getIterator();

    let dateIndex: number[] = [];
    while (iterBlack.advance()) {
        var dt = iterBlack.get("dt");
        dateIndex.push(dt);
    }

    //can't pass more than one field to RenderingSettings through .ema().series() (we need date, not only value) - drawing line instead
    const line = plot.spline(mapping);
    const renderer = line.rendering();

    // create a context for how each point will be drawn

    let prevX = 0;
    let prevY = 0;
    let currentX = 0;
    let currentY = 0;
    let reduction = 15;
    let reductionC0unter = 1;
    let firstPoint: boolean;
    let lastIndex: number = 0;
    let lastMod: number[] = [];
    let curveFactor = 0.4;

    renderer.start(() => (firstPoint = true));

    let letActiveStroke: any;
    renderer.point(function(this: any) {
        if (this.missing) return;
        const shapes = this.getShapesGroup(this.seriesState);
        const stroke = shapes["stroke"];
        //   letActiveStroke = stroke;

        if (this.getDataValue("date") > maxDate) return;

        if (firstPoint) {
            stroke.moveTo(this.x, this.value);
            firstPoint = false;
            prevX = this.x;
            prevY = this.value;

            return;
        }

        let index = dateIndex.indexOf(this.getDataValue("date"));
        if (index % reduction == 0 || index == dateIndex.length - 1) {
            var xi = interpolateNumber(prevX, this.x);
            var x2 = xi(curveFactor);
            var x3 = xi(1 - curveFactor);

            stroke.moveTo(prevX, prevY).curveTo(x2, prevY, x3, this.value, this.x, this.value);

            prevX = this.x;
            prevY = this.value;
            reductionC0unter = 1;
        }
        currentX = this.x;
        currentY = this.value;
        lastMod = [index % reduction, prevX, prevY, this.value, this.value, stroke];
        reductionC0unter++;
    });

    renderer.finish(function(this: any) {
        reductionC0unter = 1;
        const shapes = this.getShapesGroup(this.seriesState);
        const stroke = shapes["stroke"];
        if (lastMod[0] != 0) {
            var xi = interpolateNumber(prevX, currentX);
            var x2 = xi(curveFactor);
            var x3 = xi(1 - curveFactor);

            if (stroke !== undefined) {
                stroke.moveTo(prevX, prevY).curveTo(x2, prevY, x3, currentY, currentX, currentY);
            }
        }
    });

    return line;
}

function interpolateNumber(a: any, b: any) {
    return function(t: any) {
        return a * (1 - t) + b * t;
    };
}

//   anychart.wordtreeModule.Chart.prototype.drawConnector = function(x0, y0, x1, y1, curveFactor) {
//     var path = this.connectorElement_;
//     var xi = this.interpolateNumber(x0, x1);
//     var x2 = xi(curveFactor);
//     var x3 = xi(1 - curveFactor);
//     path.moveTo(x0, y0).curveTo(x2, y0, x3, y1, x1, y1);
//   };
